import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import API from "../../../utils/API";
import SectionHeader from "../../../components/views/SectionHeader";
import TabsContainer from "../../../components/views/TabsContainer";
import SectionFooter from "../../../components/views/SectionFooter";
import LoadingWizard from "../../../components/spinner/wizard";
import InputField from "../../../components/inputs/inputField";
import ToggleField from "../../../components/inputs/toggleField";
import SelectField from "../../../components/inputs/selectField";
import CreateRegistrationFlowTicketModal from "./modals/createRegistrationFlowTicketModal";
import EditTicketModal from "./modals/editTicketModal";
import DeleteTicketModal from "./modals/deleteTicketModal";
import DuplicateTicketModal from "./modals/duplicateTicketModal";
import PagePreviewFrame from "../../../views/pages/components/pagePreviewFrame";
import FormBuilderModal from "../forms/modals/formBuilder";
import RichTextEditor from "../../../views/pages/components/richTextEditor";
import PageEditor from "../pages/pageEditor";
import EmailEditor from "../../../components/email/emailEditor";
import * as IFrame from "react-iframe-form";
import TemplateCenterModal from "../emails/modals/templateCenterModal";
import Submissions from "../forms/submissions";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import TicketItem from "../../../components/tickets/TicketItem";
import DeleteFlowModal from "./modals/deleteFlowModal";
import TimeField from "../../../components/inputs/timeField";
import Payments from "./payments";
import DeleteSubmissionModal from "../forms/modals/deleteSubmissionModal";
import ActionButtonContainer from "../../../components/views/ActionButtonContainer";
import AlertBar from "../../../components/custom/alertBar";
import Select from 'react-select';
import SendTestTemplateModal from "../emails/modals/sendTestTemplateModal";

function ValidateEmail(mail) {
    var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return mail.match(mailformat) ? true : false;
}

const ENV =
    process.env.NODE_ENV === "production"
        ? window.location.href.includes("planner.simple.events")
            ? `https://admin-api.simple.events/`
            : `https://beta-api.simple.events/`
        : `http://${window.location.hostname}:5015/`;

const baseFieldList = [
    {
        _id: "attendee",
        title: "Attendee Basic Detail Fields",
        fields: [
            {
                _id: "_firstName",
                fieldName: "First Name",
                fieldType: "text",
                required: true,
                propertyType: "attendee",
            },
            {
                _id: "_lastName",
                fieldName: "Last Name",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_email",
                fieldName: "Email",
                fieldType: "email",
                required: true,
                propertyType: "attendee",
            },
            {
                _id: "_phoneNumber",
                fieldName: "Phone Number",
                fieldType: "tel",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_title",
                fieldName: "Title",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_company",
                fieldName: "Company",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_textMessageOptIn",
                fieldName: "Text Message Opt In",
                fieldType: "checkbox",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_dietaryPreference",
                fieldName: "Dietary Preference",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_foodAllergies",
                fieldName: "Food Allergies",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_emergencyContactName",
                fieldName: "Emergency Contact Name",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_emergencyContactPhoneNumber",
                fieldName: "Emergency Contact Phone Number",
                fieldType: "tel",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_address",
                fieldName: "Address",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_address2",
                fieldName: "Address 2",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_city",
                fieldName: "City",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_state",
                fieldName: "State",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_zip",
                fieldName: "Zip",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_country",
                fieldName: "Country",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_profilePicture",
                fieldName: "Profile Picture",
                fieldType: "profileImage",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_NPINumber",
                fieldName: "NPI Number",
                fieldType: "NPINumber",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_bcc",
                fieldName: "BCC",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
        ],
    },
    {
        _id: "rooming",
        title: "Attendee Rooming Fields",
        fields: [
            {
                _id: "_roomingInformation-arrivalDate",
                fieldName: "Arrival Date",
                fieldType: "date",
                propertyType: "attendee",
            },
            {
                _id: "_roomingInformation-arrivalTime",
                fieldName: "Arrival Time",
                fieldType: "time",
                propertyType: "attendee",
            },
            {
                _id: "_roomingInformation-checkInDate",
                fieldName: "Check In Date",
                fieldType: "date",
                propertyType: "attendee",
            },
            {
                _id: "_roomingInformation-departureDate",
                fieldName: "Departure Date",
                fieldType: "date",
                propertyType: "attendee",
            },
            {
                _id: "_roomingInformation-departureTime",
                fieldName: "Departure Time",
                fieldType: "time",
                propertyType: "attendee",
            },
            {
                _id: "_roomingInformation-checkOutDate",
                fieldName: "Check Out Date",
                fieldType: "date",
                propertyType: "attendee",
            },
            {
                _id: "_roomingInformation-numberOfDaysStay",
                fieldName: "Number of Nights",
                fieldType: "number",
                propertyType: "attendee",
            },
            {
                _id: "_roomingInformation-roomType",
                fieldName: "Room Type",
                fieldType: "text",
                propertyType: "attendee",
            },
            {
                _id: "_roomingInformation-hotelConfirmationNumber",
                fieldName: "Hotel Confirmation Number",
                fieldType: "text",
                propertyType: "attendee",
            },
        ],
    },
    {
        _id: "travel",
        title: "Attendee Travel Fields",
        fields: [
            {
                _id: "_travelInformation-originCity",
                fieldName: "Origin City",
                fieldType: "text",
                propertyType: "attendee",
            },
            {
                _id: "_travelInformation-originState",
                fieldName: "Origin State",
                fieldType: "text",
                propertyType: "attendee",
            },
            {
                _id: "_travelInformation-arrivalCity",
                fieldName: "Arrival City",
                fieldType: "text",
                propertyType: "attendee",
            },
            {
                _id: "_travelInformation-arrivalState",
                fieldName: "Arrival State",
                fieldType: "text",
                propertyType: "attendee",
            },
            {
                _id: "_travelInformation-arrivalDate",
                fieldName: "Arrival Date",
                fieldType: "date",
                propertyType: "attendee",
            },
            {
                _id: "_travelInformation-arrivalTime",
                fieldName: "Arrival Time",
                fieldType: "time",
                propertyType: "attendee",
            },
            {
                _id: "_travelInformation-arrivalCarrier",
                fieldName: "Arrival Carrier",
                fieldType: "text",
                propertyType: "attendee",
            },
            {
                _id: "_travelInformation-arrivalFlight",
                fieldName: "Arrival Flight",
                fieldType: "text",
                propertyType: "attendee",
            },
            {
                _id: "_travelInformation-arrivalTicketed",
                fieldName: "Arrival Ticketed",
                fieldType: "text",
                propertyType: "attendee",
            },
            {
                _id: "_travelInformation-arrivalClassOfService",
                fieldName: "Arrival Class of Service",
                fieldType: "text",
                propertyType: "attendee",
            },
            {
                _id: "_travelInformation-arrivalLocator",
                fieldName: "Arrival Locator",
                fieldType: "text",
                propertyType: "attendee",
            },
        ],
    },
    {
        _id: "special",
        title: "Special Function Fields",
        fields: [
            {
                _id: "_additionalAttendees",
                fieldName: "Additional Attendees",
                fieldType: "additionalAttendees",
                propertyType: "base",
                moduleConfiguration: {
                    label: "Guest",
                    maxAttendees: 2,
                    associatedGroup: null,
                    defaultStatus: "registered",
                    confirmationEmail: null,
                    fields: [
                        {
                            _id: "_firstName",
                            attendeeField: {
                                propertyType: "base",
                                propertyName: "firstName",
                            },
                            columnClass: "col-12",
                            description: "",
                            disabled: false,
                            id: "_attendeeFirstName",
                            label: "First Name",
                            objectClass: "xbaseInput",
                            options: [],
                            placeholder: "",
                            required: true,
                            style: "",
                            type: "text",
                            static: true,
                        },
                        {
                            _id: "_lastName",
                            attendeeField: { propertyType: "base", propertyName: "lastName" },
                            columnClass: "col-12",
                            description: "",
                            disabled: false,
                            id: "_attendeeLastName",
                            label: "Last Name",
                            objectClass: "xbaseInput",
                            options: [],
                            placeholder: "",
                            required: false,
                            style: "",
                            type: "text",
                            static: false,
                        },
                        {
                            _id: "_email",
                            attendeeField: { propertyType: "base", propertyName: "email" },
                            columnClass: "col-12",
                            description: "",
                            disabled: false,
                            id: "_attendeeEmail",
                            label: "Email",
                            objectClass: "xbaseInput",
                            options: [],
                            placeholder: "",
                            required: true,
                            style: "",
                            type: "email",
                            static: true,
                        },
                    ],
                },
            },
            {
                _id: "*notifierEmail",
                fieldName: "Notifier Email",
                fieldType: "notifierEmail",
                propertyType: "custom",
                moduleConfiguration: {
                    notificationEmail: null,
                },
            },
            {
                _id: "_medProLookup",
                fieldName: "MedPro Lookup",
                fieldType: "medProLookup",
                propertyType: "base",
                moduleConfiguration: {
                    medProID: false,
                    medProMasterID: false,
                    firstName: false,
                    lastName: false,
                    suffix: false,
                    title: false,
                    address: false,
                    licenseNumber: false,
                    licenseState: false,
                },
            },
            {
                _id: "_salesForceSearchContact",
                fieldName: "Salesforce Search Contact",
                fieldType: "salesForceSearchContact",
                propertyType: "base",
                moduleConfiguration: {
                    medProID: false,
                    medProMasterID: false,
                    firstName: false,
                    lastName: false,
                    suffix: false,
                    title: false,
                    address: false,
                    licenseNumber: false,
                    licenseState: false,
                },
            },
            {
                _id: "_salesForceSearchAccount",
                fieldName: "Salesforce Search Account",
                fieldType: "salesForceSearchAccount",
                propertyType: "base",
                moduleConfiguration: {
                    medProID: false,
                    medProMasterID: false,
                    firstName: false,
                    lastName: false,
                    suffix: false,
                    title: false,
                    address: false,
                    licenseNumber: false,
                    licenseState: false,
                },
            },
            {
                _id: "*groupSelection",
                fieldName: "Group Selection",
                fieldType: "groupSelection",
                propertyType: "custom",
                moduleConfiguration: {},
            },
            {
                _id: '_singleInventoryRedemption',
                fieldName: 'Single Inventory Redemption',
                fieldType: 'singleInventoryRedemption',
                propertyType: 'custom',
            },
        ],
    },
];

const pageAvailabilityOptions = [
    { value: true, label: "Public (Available to anyone)" },
    { value: false, label: "Private (Only for logged in users)" },
];

class RegistrationFlowSetup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            selectedSection: "setup",
            editing: false,
            error: null,
            registrationFlowConfiguration: {},
            baseRegistrationFlowConfiguration: {},
            tabs: [
                { title: "Setup", id: "setup" },
                { title: "Form Design", id: "design" },
                { title: "Confirmation", id: "confirmation" },
                { title: "Publish", id: "deploy" },
            ],
            groupNames: [
                ...props.event.groups.filter((group) => !group.dynamicGroup).map((group) => {
                    return { value: group._id, label: group.name, color: "#00B8D9" };
                }),
            ],
            addTicketModalOpen: false,
            formBuilderModalOpen: false,
            pageBuilderModalOpen: false,
            emailBuilderModalOpen: false,
            emailTemplateModalOpen: false,
            additionalAttendeeEmailBuilderModalOpen: false,
            additionalAttendeeEmailTemplateModalOpen: false,
            pageTemplates: [],
            editCount: 0,
            editedForm: {},
            editingRegistrationForm: false,
            customBaseFields: this.props.fields.map((category) => {
                const title = category.title;
                const headers = category.fields.map((field) => {
                    return {
                        _id: field._id,
                        fieldName: field.fieldName,
                        fieldType: field.fieldType,
                        required: false,
                        disabled: false,
                        propertyType: 'attendee'
                    };
                });
                return {
                    _id: 'custom',
                    title: `${title} (Custom)`,
                    fields: headers
                };
            }),
            keyedMetadata: {},
            keyedData: {},
            templates: [],
            platformTemplates: [],
            defaultSenderEmail: null,
            defaultSenderName: null,
            linkCopied: false,
            deleteFlowModalOpen: false,
            integrations: {},
            newGroupChosen: false,
            editingSubmissions: false,
            checkedSubmission: {},
            toggleDeleteSubmission: false,
            availableEmails: [],
            validBcc: true,
            toggleSendTestEmail: false,
            confUserName: '',
            confDomainName: '',
            authorizedEmailDomains: this.props.authorizedEmailDomains || [],
        };
    }

    async componentDidMount() {
        const { orgId, eventId, organization, event } = this.props;
        const flowId = this.props.match.params.flowId;
        const orgIntegrations = {};
        organization.integrations.forEach((integration) => {
            orgIntegrations[integration.identifier] = integration;
        });

        await API()
            .get(`Organizations/${orgId}/getTemplates?templateType=registration`)
            .then((res) => {
                let platformTemplates = [];

                if (res.data) {
                    platformTemplates = res.data.map((template) => {
                        return {
                            value: template._id,
                            label: template.title,
                            color: "#00B8D9",
                        };
                    });
                }
                this.setState({ pageTemplates: platformTemplates });
            });
        await API()
            .get(`Organizations/${orgId}/events/${eventId}/emails`)
            .then((res) => {
                if (res.data) {
                    let defaultSenderEmail = res.data.defaultSenderEmail;
                    let defaultSenderName = res.data.defaultSenderName;
                    const templates = res.data.templates.map((template) => {
                        return {
                            ...template,
                            link: `/${this.props.orgId}/events/${eventId}/emails/templates/${template._id}`,
                        };
                    });
                    const platformTemplates = res.data.platformTemplates;
                    const metadataOptions = [];
                    Object.keys(res.data.keyedData).forEach((key) => {
                        const layer1 = res.data.keyedData[key];
                        if (typeof layer1 === 'object') {
                            Object.keys(layer1).forEach((key2) => {
                                const layer2 = layer1[key2];
                                const k2 = key2.substring(0, 1) + key2.substring(1);
                                if (typeof layer2 === 'object') {
                                    Object.keys(layer2).forEach((key3) => {
                                        const layer3 = layer2[key3];
                                        const k3 = key3.substring(0, 1) + key3.substring(1);
                                        if (
                                            key !== '_defaultLabel' &&
                                            key2 !== '_defaultLabel' &&
                                            key3 !== '_defaultLabel'
                                        ) {
                                            //metadataOptions.push(`${key}.${key2}.${key3}`);
                                            metadataOptions.push({
                                                label: `${layer1._defaultLabel} ${layer2._defaultLabel} ${layer3}`,
                                                value: `{{${key}${k2}${k3}}}`,
                                                text: `${key}${k2}${k3}`
                                            });
                                        }
                                    });
                                } else {
                                    if (key !== '_defaultLabel' && key2 !== '_defaultLabel') {
                                        //metadataOptions.push(`${key}.${key2}`);
                                        metadataOptions.push({
                                            label: `${layer1._defaultLabel} ${layer2}`,
                                            value: `{{${key}${k2}}}`,
                                            text: `${key}${k2}`
                                        });
                                    }
                                }
                            });
                        } else {
                            if (key !== '_defaultLabel') {
                                metadataOptions.push({ label: layer1, value: key, text: `{{${key}}}` });
                            }
                        }
                    });
                    this.setState({
                        keyedMetadata: metadataOptions,
                        customFields: metadataOptions,
                        keyedData: res.data.keyedData,
                        templates: templates,
                        platformTemplates: platformTemplates,
                        defaultSenderEmail: defaultSenderEmail,
                        defaultSenderName: defaultSenderName,
                        availableEmails: [
                            { label: 'No Email', value: '' },
                            ...res.data.templates.map((e) => ({
                                value: e._id,
                                label: e.name,
                            })),
                        ],
                    });
                }
            });

        API()
            .get(
                `Organizations/${orgId}/events/${eventId}/registrationFlows/${flowId}`
            )
            .then((res) => {
                if (res.data) {
                    const flow = {
                        ...res.data,
                        registrationGroup: res.data.registrationGroup
                            ? this.state.groupNames.find(
                                (group) => group.value === res.data.registrationGroup
                            )
                            : null,
                        startDate: res.data.startDate
                            ? new Date(res.data.startDate).toISOString().split("T")[0]
                            : "",
                        endDate: res.data.endDate
                            ? new Date(res.data.endDate).toISOString().split("T")[0]
                            : "",
                        authorizedEmailDomains: res.data.authorizedEmailDomains || []
                    };
                    const baseFlow = JSON.parse(JSON.stringify(flow));

                    let tabs = this.state.tabs;
                    if (baseFlow.page && baseFlow.page.published) {
                        tabs.push({ title: "Submissions", id: "submissions" });

                        // Add payments tab if page is published and ticketing is enabled
                        if (baseFlow.ticketingEnabled) {
                            tabs.push({ title: "Payments", id: "payments" });
                        }
                    }

                    if (baseFlow.ticketingEnabled) {
                        //add tickets tab in between setup and design
                        const designIndex = tabs.findIndex((tab) => tab.id === "design");
                        if (designIndex !== -1) {
                            tabs.splice(designIndex, 0, { title: "Tickets", id: "tickets" });
                        }
                    }

                    if (orgIntegrations && orgIntegrations.salesforce) {
                        // add integrations tab before publish tab
                        if (!tabs.find((tab) => tab.id === "integrations")) {
                            const publishIndex = tabs.findIndex((tab) => tab.id === "deploy");
                            if (publishIndex !== -1) {
                                tabs.splice(publishIndex, 0, { title: "Integrations", id: "integrations" });
                            }
                        }
                        if (!event.integrations?.salesforce?.campaignName) {
                            flow.salesforceLeadEnabled = false;
                            baseFlow.salesforceLeadEnabled = false;
                        }
                    }

                    if (baseFlow.form?.additionalAttendeeConfirmationEmailEnabled) {
                        if (!tabs.find((t) => t.id === "additionalAttendeeConfirmation")) {
                            const confirmationIndex = tabs.findIndex((t) => t.id === "confirmation");
                            tabs.splice(confirmationIndex + 1, 0, { title: "Additional Attendee Email", id: "additionalAttendeeConfirmation" });
                        }
                    }
                    this.setState({
                        registrationFlowConfiguration: flow,
                        baseRegistrationFlowConfiguration: baseFlow,
                        loading: false,
                        tabs: tabs,
                        integrations: orgIntegrations,
                        authorizedEmailDomains: flow.authorizedEmailDomains || [],
                    });
                    this.updateConfirmationEmailDomainState(flow.form.confirmationEmail);
                }
            }).catch((err) => {
                //redirect to registration flows page if flow not found
                this.props.history.push(`/${orgId}/events/${eventId}/registrationFlows`);
            });
    }

    handleNameChange = (e) => {
        const originalGroups = this.state.groupNames.filter(group => !group.new);
        if (!e || e.trim() === '') {
            this.setState({
                groupNames: originalGroups
            });
            return;
        }

        const filteredGroupNames = originalGroups.filter((group) =>
            group.label.toLowerCase().includes(e.toLowerCase())
        );

        const exactMatch = originalGroups.some(group =>
            group.label.toLowerCase() === e.toLowerCase()
        );

        let updatedGroups = [...filteredGroupNames];

        if (!exactMatch && e.trim().length > 0) {
            updatedGroups.push({
                label: "New group: " + e,
                color: "#00B8D9",
                new: true
            });
        }
        this.setState({
            groupNames: updatedGroups
        });
    };

    handleGroupChosen = (e) => {
        const { registrationFlowConfiguration } = this.state;

        if (e.new) {
            this.setState({
                registrationFlowConfiguration: {
                    ...registrationFlowConfiguration,
                    registrationGroup: { ...e, label: e.label.split("New group: ")[1] },
                },
                newGroupChosen: true,
                editing: true,
            });
        } else {
            this.setState({
                registrationFlowConfiguration: {
                    ...registrationFlowConfiguration,
                    registrationGroup: e,
                },
                newGroupChosen: false,
                editing: true,
            });
        }
    };

    saveRegistrationFlowConfiguration = () => {
        const { orgId, eventId } = this.props;
        const { registrationFlowConfiguration, newGroupChosen } = this.state;

        const payload = {
            ...registrationFlowConfiguration,
            startDate: registrationFlowConfiguration.startDate,
            endDate: registrationFlowConfiguration.endDate,
        };
        if (newGroupChosen) {
            payload.registrationGroupName =
                registrationFlowConfiguration.registrationGroup.label;
            delete payload.registrationGroup;
        } else {
            payload.registrationGroup =
                registrationFlowConfiguration.registrationGroup
                    ? registrationFlowConfiguration.registrationGroup.value
                    : null;
        }

        const email = registrationFlowConfiguration.form && registrationFlowConfiguration.form.confirmationEmail;
        if (email && email._id) {
            const bccRaw = email.bcc;
            const bccEmails = (Array.isArray(bccRaw) ? bccRaw.join(',') : (bccRaw || ''))
                .replace(/ /g, '').split(',').filter(e => e !== '');

            const validBcc = bccEmails.every(e => ValidateEmail(e));
            if (!validBcc) {
                this.setState({ validBcc: false });
                return;
            }
            this.setState({ validBcc: true });

            const senderEmail = email.senderEmail || '';
            const authorizedDomains = email.authorizedEmailDomains || [];
            const senderDomain = senderEmail.includes('@') ? senderEmail.split('@')[1] : '';
            const isValidEmail = senderEmail === '' || (ValidateEmail(senderEmail) && (authorizedDomains.length === 0 || authorizedDomains.includes(senderDomain)));

            if (isValidEmail) {
                API().patch(
                    `Organizations/${orgId}/events/${eventId}/template/${email._id}`,
                    {
                        name: email.name || '',
                        bcc: bccEmails,
                        senderName: email.senderName || '',
                        senderEmail: senderEmail,
                        subject: email.subject || '',
                        previewText: email.previewText || '',
                        unsubscribeEmail: email.unsubscribeEmail || false,
                    }
                ).catch((err) => {
                    console.error('Failed to save confirmation email settings:', err?.response?.data || err.message);
                });
            }
        }

        API()
            .patch(
                `Organizations/${orgId}/events/${eventId}/registrationFlows/${registrationFlowConfiguration._id}`,
                payload
            )
            .then((res) => {
                if (res.data) {
                    const tabs = this.state.tabs;
                    if (res.data.page.published) {
                        if (!tabs.find((tab) => tab.id === "submissions")) {
                            tabs.push({ title: "Submissions", id: "submissions" });
                        }

                        // Add payments tab if page is published and ticketing is enabled
                        if (res.data.ticketingEnabled && !tabs.find((tab) => tab.id === "payments")) {
                            tabs.push({ title: "Payments", id: "payments" });
                        }
                    } else {
                        const submissionsIndex = tabs.findIndex(
                            (tab) => tab.id === "submissions"
                        );
                        if (submissionsIndex !== -1) {
                            tabs.splice(submissionsIndex, 1);
                        }

                        const paymentsIndex = tabs.findIndex(
                            (tab) => tab.id === "payments"
                        );
                        if (paymentsIndex !== -1) {
                            tabs.splice(paymentsIndex, 1);
                        }
                    }

                    if (res.data.ticketingEnabled && !tabs.find((tab) => tab.id === "tickets")) {
                        //add tickets tab in between setup and design
                        const designIndex = tabs.findIndex((tab) => tab.id === "design");
                        if (designIndex !== -1) {
                            tabs.splice(designIndex, 0, { title: "Tickets", id: "tickets" });
                        }

                        // Add payments tab if ticketing is enabled and page is published
                        if (res.data.page.published && !tabs.find((tab) => tab.id === "payments")) {
                            tabs.push({ title: "Payments", id: "payments" });
                        }
                    } else if (!res.data.ticketingEnabled && tabs.find((tab) => tab.id === "tickets")) {
                        const ticketsIndex = tabs.findIndex((tab) => tab.id === "tickets");
                        if (ticketsIndex !== -1) {
                            tabs.splice(ticketsIndex, 1);
                        }

                        // Remove payments tab if ticketing is disabled
                        const paymentsIndex = tabs.findIndex((tab) => tab.id === "payments");
                        if (paymentsIndex !== -1) {
                            tabs.splice(paymentsIndex, 1);
                        }
                    }

                    // If a new group was created, add it to the groups list
                    if (newGroupChosen && res.data.group) {
                        this.setState({
                            groupNames: [
                                ...this.state.groupNames.filter((g) => !g.new),
                                {
                                    value: res.data.group._id,
                                    label: res.data.group.name,
                                    color: "#00B8D9",
                                },
                            ],
                        });
                        this.props.updateGroup(res.data.group);
                    }

                    const updatedRegistrationFlowConfiguration = {
                        ...res.data,
                        payments: this.state.baseRegistrationFlowConfiguration.payments,
                        registrationGroup: res.data.registrationGroup
                            ? this.state.groupNames.find(
                                (g) => g.value === res.data.registrationGroup
                            )
                            : null,
                        startDate: res.data.startDate
                            ? new Date(res.data.startDate).toISOString().split("T")[0]
                            : "",
                        endDate: res.data.endDate
                            ? new Date(res.data.endDate).toISOString().split("T")[0]
                            : "",
                    };

                    this.setState({
                        baseRegistrationFlowConfiguration:
                            updatedRegistrationFlowConfiguration,
                        editing: false,
                        newGroupChosen: false,
                        tabs: tabs,
                    });

                    const group = this.props.event.groups.find(
                        (group) => group._id === res.data.registrationGroup
                    );
                    this.props.updateFlow({
                        ...updatedRegistrationFlowConfiguration,
                        registrationGroup: group,
                    });
                }
            });
    };

    updateFlowTickets = () => {
        // send back the updated tickets to the parent component in the formatted reg flow
        const tickets = this.state.registrationFlowConfiguration.tickets;
        const updatedFlow = {
            ...this.state.registrationFlowConfiguration,
            tickets: tickets,
            registrationGroup: this.props.event.groups.find(
                (group) =>
                    group._id ===
                    this.state.registrationFlowConfiguration.registrationGroup.value
            ),
        };
        this.props.updateFlow(updatedFlow);
    };

    saveRegistrationForm = async () => {
        const { orgId, eventId } = this.props;
        const { registrationFlowConfiguration } = this.state;

        const { submissions, confirmationEmail, additionalAttendeeConfirmationEmail, ...rest } =
            registrationFlowConfiguration.form;

        const payload = {
            ...rest,
        };

        if (registrationFlowConfiguration.form.confirmationEmail) {
            payload.confirmationEmail =
                registrationFlowConfiguration.form.confirmationEmail._id;
        }

        if (registrationFlowConfiguration.form.additionalAttendeeConfirmationEmail) {
            payload.additionalAttendeeConfirmationEmail =
                registrationFlowConfiguration.form.additionalAttendeeConfirmationEmail._id;
        }

        const updatedFormData = await API().patch(
            `Organizations/${orgId}/events/${eventId}/forms/${registrationFlowConfiguration.form._id}`,
            payload
        );
        const updatedForm = updatedFormData.data;
        if (registrationFlowConfiguration.form.confirmationEmail) {
            updatedForm.confirmationEmail =
                registrationFlowConfiguration.form.confirmationEmail;
        }
        if (registrationFlowConfiguration.form.additionalAttendeeConfirmationEmail) {
            updatedForm.additionalAttendeeConfirmationEmail =
                registrationFlowConfiguration.form.additionalAttendeeConfirmationEmail;
        }

        this.setState({
            registrationFlowConfiguration: {
                ...registrationFlowConfiguration,
                form: updatedForm,
            },
            baseRegistrationFlowConfiguration: {
                ...this.state.baseRegistrationFlowConfiguration,
                form: updatedForm,
            },
            editingRegistrationForm: false,
            editCount: this.state.editCount + 1,
        });
    };

    deleteFormSubmission = async (callback) => {
        const { eventId, orgId } = this.props;
        const { registrationFlowConfiguration, baseRegistrationFlowConfiguration, editingSubmissions, checkedSubmission } = this.state;

        if (editingSubmissions && Object.keys(checkedSubmission).length > 0) {
            await API()
                .patch(`Organizations/${orgId}/events/${eventId}/forms/${registrationFlowConfiguration.form._id}`, {
                    deletedSubmissions: Object.keys(checkedSubmission)
                })
                .then((res) => {
                    if (res.data) {
                        const editForm = JSON.parse(JSON.stringify({ ...registrationFlowConfiguration.form, ...res.data }));
                        this.setState({
                            registrationFlowConfiguration: {
                                ...registrationFlowConfiguration,
                                form: { ...registrationFlowConfiguration.form, ...res.data },
                            },
                            baseRegistrationFlowConfiguration: {
                                ...baseRegistrationFlowConfiguration,
                                form: editForm,
                            },
                            editing: false,
                            formEditorTabSelected: 0,
                            focusOnField: false,
                            focusedFieldId: null,
                            focusedSectionId: null,
                            editCount: this.state.editCount + 1,
                            checkedSubmission: {},
                            editingSubmissions: false
                        }, () => {
                            // Update parent component with new submission count
                            this.props.updateFlow({
                                ...this.state.registrationFlowConfiguration,
                                form: this.state.registrationFlowConfiguration.form
                            });
                            callback && callback();
                        });
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    };

    toggleSubmissionEditing = (isEditing, checkedSubmission) => {
        this.setState({ editingSubmissions: isEditing, checkedSubmission: checkedSubmission || {} });
    }

    cancelSubmissionEdit = () => {
        const { editingSubmissions } = this.state;
        if (editingSubmissions) {
            this.setState({ editingSubmissions: false, checkedSubmission: {} });
        }
    }

    toggleDeleteSubmission = () => {
        const { toggleDeleteSubmission } = this.state;
        this.setState({ toggleDeleteSubmission: !toggleDeleteSubmission })
    }

    updatePage = async (updatedPage) => {
        this.setState({
            registrationFlowConfiguration: {
                ...this.state.registrationFlowConfiguration,
                page: updatedPage,
            },
            baseRegistrationFlowConfiguration: {
                ...this.state.baseRegistrationFlowConfiguration,
                page: updatedPage,
            },
        });
    };

    updateTemplateHtml = async (emailTemplate) => {
        const { orgId, eventId } = this.props;
        const { registrationFlowConfiguration } = this.state;

        await API()
            .patch(
                `Organizations/${orgId}/events/${eventId}/template/${registrationFlowConfiguration.form.confirmationEmail._id}`,
                {
                    name: emailTemplate.name,
                    html: emailTemplate.html,
                    parameters: emailTemplate.parameters,
                    emailStyles: emailTemplate.emailStyles,
                    emailComponents: emailTemplate.emailComponents,
                    codeOnly: emailTemplate.codeOnly,
                }
            )
            .then((res) => {
                if (res.data) {
                    this.setState({
                        registrationFlowConfiguration: {
                            ...registrationFlowConfiguration,
                            form: {
                                ...registrationFlowConfiguration.form,
                                confirmationEmail: res.data,
                            },
                        },
                        baseRegistrationFlowConfiguration: {
                            ...this.state.baseRegistrationFlowConfiguration,
                            form: {
                                ...this.state.baseRegistrationFlowConfiguration.form,
                                confirmationEmail: res.data,
                            },
                        },
                    });
                }
            });
    };

    updateAdditionalAttendeeTemplateHtml = async (emailTemplate) => {
        const { orgId, eventId } = this.props;
        const { registrationFlowConfiguration } = this.state;

        await API()
            .patch(
                `Organizations/${orgId}/events/${eventId}/template/${registrationFlowConfiguration.form.additionalAttendeeConfirmationEmail._id}`,
                {
                    name: emailTemplate.name,
                    html: emailTemplate.html,
                    parameters: emailTemplate.parameters,
                    emailStyles: emailTemplate.emailStyles,
                    emailComponents: emailTemplate.emailComponents,
                    codeOnly: emailTemplate.codeOnly,
                }
            )
            .then((res) => {
                if (res.data) {
                    this.setState({
                        registrationFlowConfiguration: {
                            ...registrationFlowConfiguration,
                            form: {
                                ...registrationFlowConfiguration.form,
                                additionalAttendeeConfirmationEmail: res.data,
                            },
                        },
                        baseRegistrationFlowConfiguration: {
                            ...this.state.baseRegistrationFlowConfiguration,
                            form: {
                                ...this.state.baseRegistrationFlowConfiguration.form,
                                additionalAttendeeConfirmationEmail: res.data,
                            },
                        },
                    });
                }
            });
    };

    cancelEdit = () => {
        const { baseRegistrationFlowConfiguration } = this.state;
        this.setState({
            registrationFlowConfiguration: {
                ...baseRegistrationFlowConfiguration,
                startDate: baseRegistrationFlowConfiguration.startDate
                    ? new Date(baseRegistrationFlowConfiguration.startDate)
                        .toISOString()
                        .split("T")[0]
                    : "",
                endDate: baseRegistrationFlowConfiguration.endDate
                    ? new Date(baseRegistrationFlowConfiguration.endDate)
                        .toISOString()
                        .split("T")[0]
                    : "",
                registrationGroup: baseRegistrationFlowConfiguration.registrationGroup
                    ? this.state.groupNames.find(
                        (group) =>
                            group.value ===
                            baseRegistrationFlowConfiguration.registrationGroup.value
                    )
                    : null,
            },
            editing: false,
        });
    };

    handleCopyRegLink = () => {
        const { registrationFlowConfiguration } = this.state;
        const link = this.props.organization.hostname
            ? `https://${this.props.organization.hostname}/${this.props.event.nameSlug}/${registrationFlowConfiguration.page.pathSlug}`
            : `https://${this.props.organization.identifier}.simple.events/${this.props.event.nameSlug}/${registrationFlowConfiguration.page.pathSlug}`;
        navigator.clipboard.writeText(link).then(() => {
            this.setState({ linkCopied: true });
            setTimeout(() => {
                this.setState({ linkCopied: false });
            }, 2000);
        });
    };

    toggleSendTestEmailModal = () => {
        this.setState({ toggleSendTestEmail: !this.state.toggleSendTestEmail });
    };

    onDragTicketsEnd = (result) => {
        //reorder tickets
        const { registrationFlowConfiguration } = this.state;
        const items = Array.from(registrationFlowConfiguration.tickets);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        this.setState({
            registrationFlowConfiguration: {
                ...registrationFlowConfiguration,
                tickets: items,
            },
            editing: true,
        });
    };

    updateConfirmationEmailDomainState = (confirmationEmail) => {
        if (!confirmationEmail) {
            this.setState({ confUserName: '', confDomainName: '' });
            return;
        }

        const authorizedEmailDomains = confirmationEmail.authorizedEmailDomains
            ? confirmationEmail.authorizedEmailDomains.map((ae) => ({ value: ae, label: ae }))
            : this.state.authorizedEmailDomains.map((ae) => typeof ae === 'string' ? { value: ae, label: ae } : ae);

        const rawEmail = confirmationEmail.senderEmail || '';
        const confUserName = rawEmail.includes('@') ? rawEmail.split('@')[0] : rawEmail;
        const confDomainName = rawEmail.includes('@') ? rawEmail.split('@')[1] : (authorizedEmailDomains[0]?.value || '');

        this.setState({ authorizedEmailDomains, confUserName, confDomainName });
    };

    renderSection = () => {
        const {
            selectedSection,
            registrationFlowConfiguration,
            groupNames,
            pageBuilderModalOpen,
            editCount,
            emailBuilderModalOpen,
            editing,
            baseRegistrationFlowConfiguration,
            confUserName,
            confDomainName,
            authorizedEmailDomains
        } = this.state;
        const { orgId, eventId, organization, event } = this.props;
        const registrationGroup =
            registrationFlowConfiguration.registrationGroup &&
            event.groups.find(
                (group) =>
                    group._id ===
                    registrationFlowConfiguration.registrationGroup.value
            );
        const hasTemplate = registrationFlowConfiguration.form.confirmationEmail != null;
        switch (selectedSection) {
            case "setup":
                return (
                    <div className="blocksContainer">
                        <div className="flex w-100 gap20">
                            <div className="sectionBlock contained-h">
                                <h2 className="blockHeader">General Flow Details</h2>
                                <InputField
                                    label="Registration Flow Name"
                                    required={true}
                                    value={registrationFlowConfiguration.name}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                name: e.target.value,
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                                <div className="flex gap10">
                                    <InputField
                                        label="Start Date"
                                        classes={"w-100"}
                                        type="date"
                                        required
                                        inputIcon={<i className="lar la-calendar" />}
                                        name="startDate"
                                        placeholder="Enter start date"
                                        value={registrationFlowConfiguration.startDate}
                                        onChange={(e) => {
                                            this.setState({
                                                registrationFlowConfiguration: {
                                                    ...registrationFlowConfiguration,
                                                    startDate: e.target.value,
                                                },
                                                editing: true,
                                            });
                                        }}
                                    />
                                    <TimeField
                                        label="Start Time"
                                        classes={"w-100"}
                                        value={registrationFlowConfiguration.startTime}
                                        type="time"
                                        required
                                        inputIcon={<i className="lar la-clock" />}
                                        name="startTime"
                                        placeholder="Enter start time"
                                        onChange={(e) => {
                                            this.setState({
                                                registrationFlowConfiguration: {
                                                    ...registrationFlowConfiguration,
                                                    startTime: e,
                                                },
                                                editing: true,
                                            });
                                        }}
                                    />
                                </div>
                                <div className="flex gap10">
                                    <InputField
                                        label="End Date"
                                        classes={"w-100"}
                                        type="date"
                                        required
                                        inputIcon={<i className="lar la-calendar" />}
                                        name="endDate"
                                        placeholder="Enter end date"
                                        value={registrationFlowConfiguration.endDate}
                                        onChange={(e) => {
                                            this.setState({
                                                registrationFlowConfiguration: {
                                                    ...registrationFlowConfiguration,
                                                    endDate: e.target.value,
                                                },
                                                editing: true,
                                            });
                                        }}
                                        min={registrationFlowConfiguration.startDate}
                                    />
                                    <TimeField
                                        label="End Time"
                                        classes={"w-100"}
                                        value={registrationFlowConfiguration.endTime}
                                        type="time"
                                        required
                                        inputIcon={<i className="lar la-clock" />}
                                        name="endTime"
                                        placeholder="Enter end time"
                                        onChange={(e) => {
                                            this.setState({
                                                registrationFlowConfiguration: {
                                                    ...registrationFlowConfiguration,
                                                    endTime: e,
                                                },
                                                editing: true,
                                            });
                                        }}
                                    />
                                </div>

                                <SelectField
                                    label="Availability"
                                    required={true}
                                    classes="w-100"
                                    information="Private pages will enable advance form configurations to logged in attendees."
                                    placeholder="Page availability"
                                    value={
                                        registrationFlowConfiguration.page.openToPublic
                                            ? pageAvailabilityOptions[0]
                                            : pageAvailabilityOptions[1]
                                    }
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                page: {
                                                    ...registrationFlowConfiguration.page,
                                                    openToPublic: e.value,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                    options={pageAvailabilityOptions}
                                />

                                <InputField
                                    subText={`https://${organization.hostname
                                        ? organization.hostname
                                        : organization.identifier + ".simple.events"
                                        }/${event.nameSlug}/${registrationFlowConfiguration.page.pathSlug
                                        }`}
                                    label="Page Web Address"
                                    required={true}
                                    placeholder="Unique slug for this page"
                                    value={registrationFlowConfiguration.page.pathSlug}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                page: {
                                                    ...registrationFlowConfiguration.page,
                                                    pathSlug: e.target.value,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                                <InputField
                                    label="Page Title"
                                    required={true}
                                    value={registrationFlowConfiguration.page.title}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                page: {
                                                    ...registrationFlowConfiguration.page,
                                                    title: e.target.value,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                                <InputField
                                    label="Page Description"
                                    required={true}
                                    value={registrationFlowConfiguration.page.description}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                page: {
                                                    ...registrationFlowConfiguration.page,
                                                    description: e.target.value,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />

                                {/* <ToggleField
                                    label="Enable Paid Tickets"
                                    classes={"w-100"}
                                    checked={registrationFlowConfiguration.ticketingEnabled}
                                    icons={false}
                                    information="Enable ticketing if you wish to sell tickets for this flow."
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                ticketingEnabled: e.target.checked,
                                            },
                                            editing: true,
                                        });
                                    }}
                                /> */}
                                <SelectField
                                    label="Registration Group"
                                    classes={"w-100"}
                                    name="groupName"
                                    information="Select or create a group attendees that will be added to when they register in this flow."
                                    options={groupNames}
                                    required
                                    onChange={this.handleGroupChosen}
                                    onInputChange={this.handleNameChange}
                                    value={registrationFlowConfiguration.registrationGroup}
                                />

                                <ToggleField
                                    label="Enable Attendance Confirmation"
                                    checked={registrationFlowConfiguration.form.rsvpEnabled}
                                    icons={false}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    rsvpEnabled: e.target.checked,
                                                    denialEnabled: !e.target.checked ? false : registrationFlowConfiguration.form.denialEnabled,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />

                                {registrationFlowConfiguration.form.rsvpEnabled && <ToggleField
                                    label="Allow attendees to decline attendance"
                                    checked={registrationFlowConfiguration.form.denialEnabled}
                                    icons={false}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    denialEnabled: e.target.checked,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />}
                            </div>
                        </div>
                    </div>
                );
            case "tickets":
                return (
                    <div className="blocksContainer">
                        <div className="flex w-100 gap20">
                            <div className="sectionBlock contained-h">
                                <h2 className="blockHeader">Paid Ticketing Setup</h2>
                                <InputField
                                    label="Ticket Page Title"
                                    required={false}
                                    placeholder="Get your tickets"
                                    value={registrationFlowConfiguration.ticketPageTitle}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                ticketPageTitle: e.target.value,
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                                <InputField
                                    label="Ticket Page Description"
                                    required={false}
                                    placeholder="Purchase tickets to attend this event."
                                    value={registrationFlowConfiguration.ticketPageDescription}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                ticketPageDescription: e.target.value,
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                                <InputField
                                    label="Payment Screen Title"
                                    required={false}
                                    placeholder="Payment"
                                    value={registrationFlowConfiguration.paymentScreenTitle}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                paymentScreenTitle: e.target.value,
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                                <InputField
                                    label="Payment Screen Description"
                                    required={false}
                                    placeholder="Enter payment information to complete your registration."
                                    value={registrationFlowConfiguration.paymentScreenDescription}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                paymentScreenDescription: e.target.value,
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                            </div>
                            {registrationFlowConfiguration.ticketingEnabled && (
                                <div className="sectionBlock contained-h">
                                    <div className="flex aic jcsb mt-20">
                                        <div className="w-100">
                                            <h2 className="blockHeader m-0">Paid Tickets</h2>
                                            <p className="mb-0">
                                                Drag tickets to organize their order on the registration
                                                form
                                            </p>
                                        </div>
                                        <button
                                            className={`prim ${this.state.editing ? "disabled" : ""}`}
                                            onClick={() => {
                                                this.setState({ addTicketModalOpen: true });
                                            }}
                                            disabled={this.state.editing}
                                        >
                                            Add Ticket
                                        </button>
                                    </div>
                                    <div className="ticketsContainer mt-20">
                                        <DragDropContext onDragEnd={this.onDragTicketsEnd}>
                                            <Droppable droppableId="droppable">
                                                {(provided) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.droppableProps}
                                                        className="draggableTicketsContainer"
                                                    >
                                                        {registrationFlowConfiguration.tickets.map(
                                                            (ticket, index) => {
                                                                //view only with edit, duplicate, and delete options
                                                                return (
                                                                    <Draggable
                                                                        key={ticket._id}
                                                                        draggableId={ticket._id}
                                                                        index={index}
                                                                    >
                                                                        {(provided, snapshot) => (
                                                                            <div
                                                                                ref={provided.innerRef}
                                                                                {...provided.draggableProps}
                                                                                className={`draggableGridItem `}
                                                                                style={{
                                                                                    backgroundColor: snapshot.isDragging
                                                                                        ? "#f5f5f5"
                                                                                        : undefined,
                                                                                    ...provided.draggableProps.style,
                                                                                }}
                                                                            >
                                                                                <TicketItem
                                                                                    ticket={ticket}
                                                                                    draggable={true}
                                                                                    providedDrag={
                                                                                        provided.dragHandleProps
                                                                                    }
                                                                                    providedDrop={provided}
                                                                                    isDragging={snapshot.isDragging}
                                                                                    onEdit={() => {
                                                                                        this.setState({
                                                                                            editingTicket: ticket,
                                                                                            editTicketModalOpen: true,
                                                                                        });
                                                                                    }}
                                                                                    onDuplicate={() => {
                                                                                        this.setState({
                                                                                            duplicatingTicket: ticket,
                                                                                            duplicateTicketModalOpen: true,
                                                                                        });
                                                                                    }}
                                                                                    onDelete={() => {
                                                                                        this.setState({
                                                                                            deletingTicket: ticket,
                                                                                            deleteTicketModalOpen: true,
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </Draggable>
                                                                );
                                                            }
                                                        )}
                                                    </div>
                                                )}
                                            </Droppable>
                                        </DragDropContext>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                );
            case "design":
                return (
                    <div className="blocksContainer">
                        <div className="flex w-100 gap20">
                            <div className="sectionBlock contained-h">
                                <h2 className="blockHeader">Registration Form Details</h2>
                                <InputField
                                    label="Registration Not Yet Open Title"
                                    required={false}
                                    value={registrationFlowConfiguration.form.formNotOpenYetTitle}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    formNotOpenYetTitle: e.target.value,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />

                                <InputField
                                    label="Registration Not Yet Open Message"
                                    required={false}
                                    placeholder=""
                                    information="Will display opening date and time with or without message."
                                    value={registrationFlowConfiguration.form.formNotOpenYetMessage}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    formNotOpenYetMessage: e.target.value,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                                <InputField
                                    label="Registration Closed Title"
                                    required={false}
                                    value={registrationFlowConfiguration.form.formClosedTitle}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    formClosedTitle: e.target.value,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />

                                <InputField
                                    label="Registration Closed Message"
                                    required={false}
                                    value={registrationFlowConfiguration.form.formClosedMessage}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    formClosedMessage: e.target.value,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />

                                {registrationGroup && registrationGroup.maxCapacityEnabled && (
                                    <div>
                                        <InputField
                                            label="Registration Group Max Capacity Reached Title"
                                            required={false}
                                            placeholder="Registration is at capacity"
                                            value={registrationFlowConfiguration.form.maxCapTitle}
                                            onChange={(e) => {
                                                this.setState({
                                                    registrationFlowConfiguration: {
                                                        ...registrationFlowConfiguration,
                                                        form: {
                                                            ...registrationFlowConfiguration.form,
                                                            maxCapTitle: e.target.value,
                                                        },
                                                    },
                                                    editing: true,
                                                });
                                            }}
                                        />
                                        <InputField
                                            label="Max Capacity Message"
                                            required={false}
                                            placeholder="This registration has reached capacity"
                                            value={
                                                registrationFlowConfiguration.form.maxCapacityMessage
                                            }
                                            onChange={(e) => {
                                                this.setState({
                                                    registrationFlowConfiguration: {
                                                        ...registrationFlowConfiguration,
                                                        form: {
                                                            ...registrationFlowConfiguration.form,
                                                            maxCapacityMessage: e.target.value,
                                                        },
                                                    },
                                                    editing: true,
                                                });
                                            }}
                                        />
                                    </div>
                                )}

                                {registrationFlowConfiguration.form.rsvpEnabled && (<>
                                    <h2 className="blockHeader mt-20">Attendance Confirmation</h2>

                                    <InputField
                                        label="Submit Button Label"
                                        required={false}
                                        placeholder="Register for Event"
                                        value={registrationFlowConfiguration.form.rsvpLabel}
                                        onChange={(e) => {
                                            this.setState({
                                                registrationFlowConfiguration: {
                                                    ...registrationFlowConfiguration,
                                                    form: {
                                                        ...registrationFlowConfiguration.form,
                                                        rsvpLabel: e.target.value,
                                                    },
                                                },
                                                editing: true,
                                            });
                                        }}
                                    />
                                    {registrationFlowConfiguration.form.denialEnabled && (
                                        <div>
                                            <InputField
                                                label="Decline Button Label"
                                                required={false}
                                                placeholder="I am unable to attend"
                                                value={registrationFlowConfiguration.form.declineLabel}
                                                onChange={(e) => {
                                                    this.setState({
                                                        registrationFlowConfiguration: {
                                                            ...registrationFlowConfiguration,
                                                            form: {
                                                                ...registrationFlowConfiguration.form,
                                                                declineLabel: e.target.value,
                                                            },
                                                        },
                                                        editing: true,
                                                    });
                                                }}
                                            />

                                            <InputField
                                                label="Decline Page Title"
                                                required={false}
                                                placeholder="Sorry we missed you"
                                                value={registrationFlowConfiguration.form.declineTitle}
                                                onChange={(e) => {
                                                    this.setState({
                                                        registrationFlowConfiguration: {
                                                            ...registrationFlowConfiguration,
                                                            form: {
                                                                ...registrationFlowConfiguration.form,
                                                                declineTitle: e.target.value,
                                                            },
                                                        },
                                                        editing: true,
                                                    });
                                                }}
                                            />

                                            <RichTextEditor
                                                id="Decline_Page_Description"
                                                label="Decline Page Description"
                                                placeholder="Not attending"
                                                value={registrationFlowConfiguration.form.declineSubtitle}
                                                onChange={(e) => {
                                                    this.setState({
                                                        registrationFlowConfiguration: {
                                                            ...registrationFlowConfiguration,
                                                            form: {
                                                                ...registrationFlowConfiguration.form,
                                                                declineSubtitle: e,
                                                            },
                                                        },
                                                        editing: true,
                                                    });
                                                }}
                                                customFields={this.state.customFields}
                                            />

                                            <ToggleField
                                                label="Enable Decline Options"
                                                checked={
                                                    registrationFlowConfiguration.form.enableDeclineOptions
                                                }
                                                icons={false}
                                                onChange={(e) => {
                                                    this.setState({
                                                        registrationFlowConfiguration: {
                                                            ...registrationFlowConfiguration,
                                                            form: {
                                                                ...registrationFlowConfiguration.form,
                                                                enableDeclineOptions: e.target.checked,
                                                            },
                                                        },
                                                        editing: true,
                                                    });
                                                }}
                                            />

                                            {registrationFlowConfiguration.form
                                                .enableDeclineOptions && (
                                                    <div className="pb-20">
                                                        <div className="formFieldLabel">Decline Options</div>
                                                        {registrationFlowConfiguration.form.declineOptions.map(
                                                            (option, index) => {
                                                                return (
                                                                    <div className="flex-ac">
                                                                        <InputField
                                                                            label="Item"
                                                                            required={false}
                                                                            placeholder="Not attending"
                                                                            value={option}
                                                                            onChange={(e) => {
                                                                                registrationFlowConfiguration.form.declineOptions[
                                                                                    index
                                                                                ] = e.target.value;
                                                                                this.setState({
                                                                                    registrationFlowConfiguration,
                                                                                    editing: true,
                                                                                });
                                                                            }}
                                                                        />
                                                                        <i
                                                                            className="las la-times ml-10"
                                                                            onClick={() => {
                                                                                registrationFlowConfiguration.form.declineOptions.splice(
                                                                                    index,
                                                                                    1
                                                                                );
                                                                                this.setState({
                                                                                    registrationFlowConfiguration,
                                                                                    editing: true,
                                                                                });
                                                                            }}
                                                                        ></i>
                                                                    </div>
                                                                );
                                                            }
                                                        )}

                                                        <div
                                                            className="c-pointer flex jcc"
                                                            onClick={() => {
                                                                registrationFlowConfiguration.form.declineOptions.push(
                                                                    ""
                                                                );
                                                                this.setState({
                                                                    registrationFlowConfiguration,
                                                                    editing: true,
                                                                });
                                                            }}
                                                        >
                                                            + Add Decline Options
                                                        </div>
                                                    </div>
                                                )}

                                            {registrationFlowConfiguration.form
                                                .enableDeclineOptions && (
                                                    <ToggleField
                                                        label="Require Decline Options"
                                                        checked={
                                                            registrationFlowConfiguration.form
                                                                .requireDeclineOptions
                                                        }
                                                        icons={false}
                                                        onChange={(e) => {
                                                            this.setState({
                                                                registrationFlowConfiguration: {
                                                                    ...registrationFlowConfiguration,
                                                                    form: {
                                                                        ...registrationFlowConfiguration.form,
                                                                        requireDeclineOptions: e.target.checked,
                                                                    },
                                                                },
                                                                editing: true,
                                                            });
                                                        }}
                                                    />
                                                )}

                                            <ToggleField
                                                label="Include Decline Comment"
                                                checked={
                                                    registrationFlowConfiguration.form.enableDeclineComment
                                                }
                                                icons={false}
                                                onChange={(e) => {
                                                    this.setState({
                                                        registrationFlowConfiguration: {
                                                            ...registrationFlowConfiguration,
                                                            form: {
                                                                ...registrationFlowConfiguration.form,
                                                                enableDeclineComment: e.target.checked,
                                                            },
                                                        },
                                                        editing: true,
                                                    });
                                                }}
                                            />

                                            {registrationFlowConfiguration.form
                                                .enableDeclineComment && (
                                                    <ToggleField
                                                        label="Require Decline Comment"
                                                        checked={
                                                            registrationFlowConfiguration.form.requireComment
                                                        }
                                                        icons={false}
                                                        onChange={(e) => {
                                                            this.setState({
                                                                registrationFlowConfiguration: {
                                                                    ...registrationFlowConfiguration,
                                                                    form: {
                                                                        ...registrationFlowConfiguration.form,
                                                                        requireComment: e.target.checked,
                                                                    },
                                                                },
                                                                editing: true,
                                                            });
                                                        }}
                                                    />
                                                )}
                                        </div>
                                    )}
                                </>)}
                            </div>
                            <div className="sectionBlock  emailDesignPreview mt-20 ">
                                <div
                                    style={{
                                        maxWidth: "calc(100% - 15px)",
                                        minWidth: "calc(100% - 700px)",
                                    }}
                                    className="cardDetailsContainerPages containerTitle mb-20"
                                >
                                    <div className="w-100">
                                        <h2 className="blockHeader m-0">
                                            Registration Page Preview
                                        </h2>
                                        <p>Registration page as attendees will see</p>
                                    </div>
                                    <div className="flex aic gap10">
                                        <button
                                            className={`neu ${editing ? " disabled" : ""}`}
                                            disabled={editing}
                                            onClick={() => {
                                                this.setState({ pageBuilderModalOpen: true });
                                            }}
                                        >
                                            Edit Design
                                        </button>
                                        <button
                                            className={`neu prim ${editing ? " disabled" : ""}`}
                                            disabled={editing}
                                            onClick={() => {
                                                this.setState({
                                                    formBuilderModalOpen: true,
                                                    editingRegistrationForm: false,
                                                });
                                            }}
                                        >
                                            Edit Form
                                        </button>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        maxWidth: "calc(100% - 15px)",
                                        minWidth: "calc(100% - 700px)",
                                        height: 500,
                                    }}
                                >
                                    <div className="emailPreview eFrame pages flex-ac preview">
                                        {!pageBuilderModalOpen && (
                                            <PagePreviewFrame
                                                ENV={ENV}
                                                renderURL={`Organizations/${orgId}/events/${eventId}/pages/render/${registrationFlowConfiguration.page._id}/`}
                                                preview={true}
                                                pageProperties={registrationFlowConfiguration.page}
                                                focusedComponent={""}
                                                simulatedUser={{}}
                                                simulatedSession={{ value: false }}
                                                renderOnly={true}
                                                editing={this.state.editCount}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            case "confirmation": {
                const confirmationEmail = registrationFlowConfiguration.form.confirmationEmail || {};
                const fromNameMissing = !(confirmationEmail.senderName || '').trim();
                const fromEmailMissing = !(confirmationEmail.senderEmail || '').trim();
                const subjectMissing = !(confirmationEmail.subject || '').trim();
                return (
                    <div className="blocksContainer">
                        <div className="flex w-100 gap20">
                            <div className="sectionBlock contained-h">
                                <h2 className="blockHeader">Submission Confirmation Details</h2>
                                <ToggleField
                                    label="Enable a review page before form submission"
                                    checked={
                                        registrationFlowConfiguration.form.enableSubmissionReview
                                    }
                                    icons={false}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    enableSubmissionReview: e.target.checked,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />

                                {registrationFlowConfiguration.form.enableSubmissionReview && (
                                    <div>
                                        <InputField
                                            label="Review Page Title"
                                            required={false}
                                            placeholder="Please Review"
                                            value={
                                                registrationFlowConfiguration.form.submissionReviewTitle
                                            }
                                            onChange={(e) => {
                                                this.setState({
                                                    registrationFlowConfiguration: {
                                                        ...registrationFlowConfiguration,
                                                        form: {
                                                            ...registrationFlowConfiguration.form,
                                                            submissionReviewTitle: e.target.value,
                                                        },
                                                    },
                                                    editing: true,
                                                });
                                            }}
                                        />
                                        {/* Update */}
                                        <RichTextEditor
                                            id="Review_Page_Description"
                                            label="Review Page Description"
                                            placeholder="Look over your questions and go back if you need to edit."
                                            value={
                                                registrationFlowConfiguration.form
                                                    .submissionReviewSubtitle
                                            }
                                            onChange={(e) => {
                                                this.setState({
                                                    registrationFlowConfiguration: {
                                                        ...registrationFlowConfiguration,
                                                        form: {
                                                            ...registrationFlowConfiguration.form,
                                                            submissionReviewSubtitle: e,
                                                        },
                                                    },
                                                    editing: true,
                                                });
                                            }}
                                            customFields={this.state.customFields}
                                        />
                                    </div>
                                )}

                                <InputField
                                    label="Submission Success Title"
                                    required={false}
                                    value={registrationFlowConfiguration.form.successTitle}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    successTitle: e.target.value,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                                <RichTextEditor
                                    id="Confirmation_Page_Description"
                                    label="Submission Success Description"
                                    value={registrationFlowConfiguration.form.successSubtitle}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    successSubtitle: e,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                    customFields={this.state.customFields}
                                />

                                <ToggleField
                                    label="Send Confirmation Email"
                                    checked={
                                        registrationFlowConfiguration.form.confirmationEmailEnabled
                                    }
                                    icons={false}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    confirmationEmailEnabled: e.target.checked,
                                                },
                                            },
                                            editing: e.target.checked && !hasTemplate ? false : true,
                                        });
                                    }}
                                />

                                {registrationFlowConfiguration.form.confirmationEmailEnabled && registrationFlowConfiguration.form.confirmationEmail && (
                                    <>
                                        <h2 className="blockHeader mt-20">Email Settings</h2>
                                        <InputField
                                            label="From Name"
                                            required={true}
                                            placeholder="Simple Events Support"
                                            value={registrationFlowConfiguration.form.confirmationEmail.senderName || ''}
                                            errorTrigger={fromNameMissing}
                                            errorMessage={'From Name is required'}
                                            onChange={(e) => {
                                                this.setState({
                                                    registrationFlowConfiguration: {
                                                        ...registrationFlowConfiguration,
                                                        form: {
                                                            ...registrationFlowConfiguration.form,
                                                            confirmationEmail: {
                                                                ...registrationFlowConfiguration.form.confirmationEmail,
                                                                senderName: e.target.value,
                                                            },
                                                        },
                                                    },
                                                    editing: true,
                                                });
                                            }}
                                        />
                                        <div className='flex aic jcc'>
                                            <div className='formFieldContainer'>
                                                <div className="formField">
                                                    <div className="labelContainer">
                                                        <div className="formFieldLabel">From Email <span className="requiredField">*</span></div>
                                                        {fromEmailMissing && (
                                                            <div className="formFieldLabel error">From Email is required</div>
                                                        )}
                                                        {(confUserName !== '' ? !ValidateEmail(`${confUserName}@${confDomainName}`) : false) && (
                                                            <div className="formFieldLabel error">Invalid Email</div>
                                                        )}
                                                        {confDomainName && !authorizedEmailDomains.some(ae => ae.value === confDomainName) && (
                                                            <div className="formFieldLabel error">Domain is not registered</div>
                                                        )}
                                                    </div>
                                                    <div className='flex'>
                                                        <div
                                                            className='formFieldInputContainer'
                                                            style={{ borderRadius: '6px 0 0 6px' }}
                                                        >
                                                            <input
                                                                value={confUserName}
                                                                className="formFieldInput text-truncate"
                                                                placeholder="username"
                                                                onChange={(e) => {
                                                                    this.setState({
                                                                        registrationFlowConfiguration: {
                                                                            ...registrationFlowConfiguration,
                                                                            form: {
                                                                                ...registrationFlowConfiguration.form,
                                                                                confirmationEmail: {
                                                                                    ...registrationFlowConfiguration.form.confirmationEmail,
                                                                                    senderEmail: `${e.target.value}@${confDomainName}`,
                                                                                },
                                                                            },
                                                                        },
                                                                        editing: true,
                                                                        confUserName: e.target.value,
                                                                    });
                                                                }}
                                                            />
                                                        </div>
                                                        <div className='flex aic jcc' style={{ background: 'var(--input)', padding: '0px 5px' }}>@</div>
                                                        <Select
                                                            styles={{
                                                                valueContainer: (e) => ({ ...e, height: 30 }),
                                                                singleValue: (e) => ({ ...e, height: 30 }),
                                                                indicatorSeparator: (e) => ({ ...e, display: 'none' }),
                                                                dropdownIndicator: (e) => ({ ...e, height: 30, padding: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', width: 30 }),
                                                                input: (e) => ({ ...e, height: 30, lineHeight: 1.2 }),
                                                                option: (e) => ({ ...e, height: 30, lineHeight: 1.2 }),
                                                            }}
                                                            className='editingSelectField mergedField'
                                                            classNamePrefix="select"
                                                            value={confDomainName ? { label: confDomainName, value: confDomainName } : null}
                                                            options={authorizedEmailDomains}
                                                            onChange={(opt) => {
                                                                this.setState({
                                                                    registrationFlowConfiguration: {
                                                                        ...registrationFlowConfiguration,
                                                                        form: {
                                                                            ...registrationFlowConfiguration.form,
                                                                            confirmationEmail: {
                                                                                ...registrationFlowConfiguration.form.confirmationEmail,
                                                                                senderEmail: `${confUserName}@${opt.value}`,
                                                                            },
                                                                        },
                                                                    },
                                                                    editing: true,
                                                                    confDomainName: opt.value,
                                                                });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <InputField
                                            label="Subject"
                                            required={true}
                                            placeholder="Write your subject line"
                                            value={registrationFlowConfiguration.form.confirmationEmail.subject || ''}
                                            errorTrigger={subjectMissing}
                                            errorMessage={'Subject is required'}
                                            onChange={(e) => {
                                                this.setState({
                                                    registrationFlowConfiguration: {
                                                        ...registrationFlowConfiguration,
                                                        form: {
                                                            ...registrationFlowConfiguration.form,
                                                            confirmationEmail: {
                                                                ...registrationFlowConfiguration.form.confirmationEmail,
                                                                subject: e.target.value,
                                                            },
                                                        },
                                                    },
                                                    editing: true,
                                                });
                                            }}
                                        />
                                        <InputField
                                            label="Preview"
                                            placeholder="Write a preview message"
                                            value={registrationFlowConfiguration.form.confirmationEmail.previewText || ''}
                                            onChange={(e) => {
                                                this.setState({
                                                    registrationFlowConfiguration: {
                                                        ...registrationFlowConfiguration,
                                                        form: {
                                                            ...registrationFlowConfiguration.form,
                                                            confirmationEmail: {
                                                                ...registrationFlowConfiguration.form.confirmationEmail,
                                                                previewText: e.target.value,
                                                            },
                                                        },
                                                    },
                                                    editing: true,
                                                });
                                            }}
                                        />
                                        <InputField
                                            label="BCC"
                                            placeholder="Add emails separated by commas..."
                                            errorTrigger={this.state.validBcc === false}
                                            errorMessage={'Invalid email detected'}
                                            value={
                                                Array.isArray(registrationFlowConfiguration.form.confirmationEmail.bcc)
                                                    ? registrationFlowConfiguration.form.confirmationEmail.bcc.join(', ')
                                                    : registrationFlowConfiguration.form.confirmationEmail.bcc || ''
                                            }
                                            onChange={(e) => {
                                                this.setState({
                                                    registrationFlowConfiguration: {
                                                        ...registrationFlowConfiguration,
                                                        form: {
                                                            ...registrationFlowConfiguration.form,
                                                            confirmationEmail: {
                                                                ...registrationFlowConfiguration.form.confirmationEmail,
                                                                bcc: e.target.value,
                                                            },
                                                        },
                                                    },
                                                    editing: true,
                                                });
                                            }}
                                        />
                                        <ToggleField
                                            label="Enable Unsubscribe Link"
                                            checked={registrationFlowConfiguration.form.confirmationEmail.unsubscribeEmail || false}
                                            icons={false}
                                            onChange={(e) => {
                                                this.setState({
                                                    registrationFlowConfiguration: {
                                                        ...registrationFlowConfiguration,
                                                        form: {
                                                            ...registrationFlowConfiguration.form,
                                                            confirmationEmail: {
                                                                ...registrationFlowConfiguration.form.confirmationEmail,
                                                                unsubscribeEmail: e.target.checked,
                                                            },
                                                        },
                                                    },
                                                    editing: true,
                                                });
                                            }}
                                        />
                                    </>
                                )}

                                <ToggleField
                                    label="Send Additional Attendee Confirmation Email"
                                    checked={registrationFlowConfiguration.form.additionalAttendeeConfirmationEmailEnabled || false}
                                    icons={false}
                                    onChange={(e) => {
                                        const enabled = e.target.checked;
                                        const updatedTabs = [...this.state.tabs];
                                        const tabId = "additionalAttendeeConfirmation";
                                        if (enabled && !updatedTabs.find((t) => t.id === tabId)) {
                                            const confirmationIndex = updatedTabs.findIndex((t) => t.id === "confirmation");
                                            updatedTabs.splice(confirmationIndex + 1, 0, { title: "Additional Attendee Email", id: tabId });
                                        } else if (!enabled) {
                                            const idx = updatedTabs.findIndex((t) => t.id === tabId);
                                            if (idx !== -1) updatedTabs.splice(idx, 1);
                                        }
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    additionalAttendeeConfirmationEmailEnabled: enabled,
                                                },
                                            },
                                            tabs: updatedTabs,
                                            editing: true,
                                        });
                                    }}
                                />

                            </div>

                            {registrationFlowConfiguration.form.confirmationEmailEnabled && (
                                <div
                                    style={{ padding: 5, minWidth: 490 }}
                                    className="sectionBlock contained-h emailDesignPreview mt-20 "
                                >
                                    <div
                                        style={{
                                            maxWidth: "calc(100% - 15px)",
                                            minWidth: "calc(100% - 700px)",
                                        }}
                                        className="cardDetailsContainerPages containerTitle mb-20"
                                    >
                                        <div className="w-100">
                                            <h2 className="blockHeader m-0">
                                                Confirmation Email Preview
                                            </h2>
                                            <p>
                                                Preview of confirmation email as attendees will see.
                                            </p>
                                        </div>
                                        <div className="flex aic gap10">
                                            {registrationFlowConfiguration.form.confirmationEmail ? (
                                                <>
                                                    <button
                                                        className={`neu ${editing ? 'disabled' : ''}`}
                                                        disabled={editing}
                                                        onClick={this.toggleSendTestEmailModal}
                                                    >
                                                        Send a test
                                                    </button>
                                                    <button
                                                        className={`neu prim ${editing ? " disabled" : ""}`}
                                                        onClick={() => {
                                                            this.setState({ emailBuilderModalOpen: true });
                                                        }}
                                                    >
                                                        Edit Design
                                                    </button>
                                                </>

                                            ) : (
                                                <button
                                                    className={`neu prim ${editing ? " disabled" : ""}`}
                                                    disabled={editing}
                                                    onClick={() => {
                                                        this.setState({ emailTemplateModalOpen: true });
                                                    }}
                                                >
                                                    Choose Design
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    {registrationFlowConfiguration.form.confirmationEmail ? (
                                        <div
                                            style={{
                                                maxWidth: "calc(100% - 15px)",
                                                minWidth: "calc(100% - 700px)",
                                                height: 500,
                                            }}
                                        >
                                            <div className="emailPreview eFrame pages flex-ac preview">
                                                {!emailBuilderModalOpen && (
                                                    <IFrame.Form
                                                        id="builderPreviewFrameTemplate"
                                                        className="emailPreviewWindow Frame"
                                                        key={`template-${editCount}`}
                                                        style={{
                                                            pointerEvents: "none",
                                                            transform: "scale(0.99)",
                                                        }}
                                                        name="PreviewFrameTemp"
                                                        config={{
                                                            url: `${ENV}Organizations/${orgId}/emailrenderer?preview=true`,
                                                            method: "post",
                                                            data: registrationFlowConfiguration.form
                                                                .confirmationEmail,
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="explainerBox">
                                                <i
                                                    className="las la-info-circle"
                                                    style={{ fontSize: 50 }}
                                                ></i>
                                                <div>
                                                    <h2>Set up a confirmation email</h2>
                                                    <p>
                                                        Choose a template for your confirmation email or
                                                        create one from scratch to get started.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                );
            }
            case "additionalAttendeeConfirmation":
                return (
                    <div className="blocksContainer">
                        <div className="flex w-100 gap20">
                            <div className="sectionBlock emailDesignPreview mt-20">
                                <div
                                    style={{
                                        maxWidth: "calc(100% - 15px)",
                                        minWidth: "calc(100% - 700px)",
                                    }}
                                    className="cardDetailsContainerPages containerTitle mb-20"
                                >
                                    <div className="w-100">
                                        <h2 className="blockHeader m-0">
                                            Additional Attendee Confirmation Email
                                        </h2>
                                        <p>
                                            Email sent to each additional attendee upon registration.
                                        </p>
                                    </div>
                                    <div className="flex aic gap10">
                                        {registrationFlowConfiguration.form.additionalAttendeeConfirmationEmail ? (
                                            <>
                                                <button
                                                    className={`neu prim ${editing ? " disabled" : ""}`}
                                                    onClick={() => this.setState({ additionalAttendeeEmailBuilderModalOpen: true })}
                                                >
                                                    Edit Design
                                                </button>
                                            </>
                                        ) : (
                                            <button
                                                className={`neu prim ${editing ? " disabled" : ""}`}
                                                disabled={editing}
                                                onClick={() => this.setState({ additionalAttendeeEmailTemplateModalOpen: true })}
                                            >
                                                Choose Design
                                            </button>
                                        )}
                                    </div>
                                </div>
                                {registrationFlowConfiguration.form.additionalAttendeeConfirmationEmail ? (
                                    <div
                                        style={{
                                            maxWidth: "calc(100% - 15px)",
                                            minWidth: "calc(100% - 700px)",
                                            height: 500,
                                        }}
                                    >
                                        <div className="emailPreview eFrame pages flex-ac preview">
                                            {!this.state.additionalAttendeeEmailBuilderModalOpen && (
                                                <IFrame.Form
                                                    id="additionalAttendeeBuilderPreviewFrame"
                                                    className="emailPreviewWindow Frame"
                                                    key={`additionalAttendeeTemplate-${editCount}`}
                                                    style={{
                                                        pointerEvents: "none",
                                                        transform: "scale(0.99)",
                                                    }}
                                                    name="AdditionalAttendeePreviewFrame"
                                                    config={{
                                                        url: `${ENV}Organizations/${orgId}/emailrenderer?preview=true`,
                                                        method: "post",
                                                        data: registrationFlowConfiguration.form.additionalAttendeeConfirmationEmail,
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <div className="explainerBox">
                                            <i className="las la-info-circle" style={{ fontSize: 50 }}></i>
                                            <div>
                                                <h2>Set up an additional attendee confirmation email</h2>
                                                <p>
                                                    Choose a template or create one from scratch to get started.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
            case "submissions":
                return (
                    <Submissions
                        containsTickets={baseRegistrationFlowConfiguration.ticketingEnabled}
                        event={event}
                        eventId={eventId}
                        orgId={orgId}
                        editedForm={registrationFlowConfiguration.form}
                        form={baseRegistrationFlowConfiguration.form}
                        toggleSubmissionEditing={this.toggleSubmissionEditing}
                    />
                );

            case "deploy":
                const setupWarnings = [];
                const ticketWarnings = [];
                const designWarnings = [];
                const confirmationWarnings = [];
                const confirmationEmailWarnings = [];

                // Check setup section requirements
                if (!baseRegistrationFlowConfiguration.name ||
                    baseRegistrationFlowConfiguration.name.trim() === '') {
                    setupWarnings.push("Registration Flow Name is missing");
                }
                if (!baseRegistrationFlowConfiguration.startDate) {
                    setupWarnings.push("Start Date is missing");
                }
                if (!baseRegistrationFlowConfiguration.startTime) {
                    setupWarnings.push("Start Time is missing");
                }
                if (!baseRegistrationFlowConfiguration.endDate) {
                    setupWarnings.push("End Date is missing");
                }
                if (!baseRegistrationFlowConfiguration.endTime) {
                    setupWarnings.push("End Time is missing");
                }
                if (!baseRegistrationFlowConfiguration.page.pathSlug ||
                    baseRegistrationFlowConfiguration.page.pathSlug.trim() === '') {
                    setupWarnings.push("Page Web Address is missing");
                }
                if (!baseRegistrationFlowConfiguration.registrationGroup) {
                    setupWarnings.push("Registration Group is missing");
                }

                // Check tickets section requirements if ticketing is enabled
                let ticketingComplete = !baseRegistrationFlowConfiguration.ticketingEnabled;
                if (baseRegistrationFlowConfiguration.ticketingEnabled) {
                    if (baseRegistrationFlowConfiguration.tickets.length === 0) {
                        ticketWarnings.push("At least one ticket must be added");
                    }
                    if (!baseRegistrationFlowConfiguration.ticketPageTitle ||
                        baseRegistrationFlowConfiguration.ticketPageTitle.trim() === '') {
                        ticketWarnings.push("Ticket Page Title is missing");
                    }
                    if (!baseRegistrationFlowConfiguration.ticketPageDescription ||
                        baseRegistrationFlowConfiguration.ticketPageDescription.trim() === '') {
                        ticketWarnings.push("Ticket Page Description is missing");
                    }
                    if (!baseRegistrationFlowConfiguration.paymentScreenTitle ||
                        baseRegistrationFlowConfiguration.paymentScreenTitle.trim() === '') {
                        ticketWarnings.push("Payment Screen Title is missing");
                    }
                    if (!baseRegistrationFlowConfiguration.paymentScreenDescription ||
                        baseRegistrationFlowConfiguration.paymentScreenDescription.trim() === '') {
                        ticketWarnings.push("Payment Screen Description is missing");
                    }

                    ticketingComplete = ticketWarnings.length === 0;
                }

                // Check page design
                let pageDesignComplete = false;
                if (baseRegistrationFlowConfiguration.page?.partials?.find(partial =>
                    partial.file === 'v2/form' &&
                    partial.parameters?.find(param => param.key === 'linkedForm' && param.value !== '')
                )) {
                    pageDesignComplete = true;
                } else {
                    designWarnings.push("The registration form must be added to the page design");
                }

                // Check design section requirements
                if (!baseRegistrationFlowConfiguration.form.formClosedTitle ||
                    baseRegistrationFlowConfiguration.form.formClosedTitle.trim() === '') {
                    designWarnings.push("Registration Closed Title is missing");
                }
                if (!baseRegistrationFlowConfiguration.form.formClosedMessage ||
                    baseRegistrationFlowConfiguration.form.formClosedMessage.trim() === '') {
                    designWarnings.push("Registration Closed Message is missing");
                }

                if (registrationGroup && registrationGroup.maxCapacityEnabled) {
                    if (!baseRegistrationFlowConfiguration.form.maxCapTitle ||
                        baseRegistrationFlowConfiguration.form.maxCapTitle.trim() === '') {
                        designWarnings.push("Registration Group Max Capacity Reached Title is missing");
                    }
                    if (!baseRegistrationFlowConfiguration.form.maxCapacityMessage ||
                        baseRegistrationFlowConfiguration.form.maxCapacityMessage.trim() === '') {
                        designWarnings.push("Max Capacity Message is missing");
                    }
                }

                // Check registration form attendance confirmation settings
                if (baseRegistrationFlowConfiguration.form.rsvpEnabled) {
                    if (!baseRegistrationFlowConfiguration.form.rsvpLabel ||
                        baseRegistrationFlowConfiguration.form.rsvpLabel.trim() === '') {
                        designWarnings.push("Submit Button Label is missing when attendance confirmation is enabled");
                    }

                    // Check decline attendance settings
                    if (baseRegistrationFlowConfiguration.form.denialEnabled) {
                        if (!baseRegistrationFlowConfiguration.form.declineLabel ||
                            baseRegistrationFlowConfiguration.form.declineLabel.trim() === '') {
                            designWarnings.push("Decline Button Label is missing");
                        }
                        if (!baseRegistrationFlowConfiguration.form.declineTitle ||
                            baseRegistrationFlowConfiguration.form.declineTitle.trim() === '') {
                            designWarnings.push("Decline Page Title is missing");
                        }
                        if (!baseRegistrationFlowConfiguration.form.declineSubtitle) {
                            designWarnings.push("Decline Page Description is missing");
                        }

                        // Check decline options
                        if (baseRegistrationFlowConfiguration.form.enableDeclineOptions) {
                            if (baseRegistrationFlowConfiguration.form.declineOptions.length === 0) {
                                designWarnings.push("At least one Decline Option is missing");
                            } else if (baseRegistrationFlowConfiguration.form.declineOptions.some(
                                option => !option || option.trim() === '')) {
                                designWarnings.push("All Decline Options must have a value");
                            }
                        }
                    }
                }

                // Check registration form
                let registrationFormComplete = false;
                if (baseRegistrationFlowConfiguration.page.openToPublic) {
                    let hasEmail = false;
                    let hasFirstName = false;
                    let hasSFSearch = false;

                    baseRegistrationFlowConfiguration.form.pages.forEach(page => {
                        page.sections?.forEach(section => {
                            section.fields?.forEach(field => {
                                if (field.id === 'email') {
                                    hasEmail = true;
                                }
                                if (field.id === 'firstName') {
                                    hasFirstName = true;
                                }
                                if (field.type === 'salesForceSearchContact') {
                                    hasSFSearch = true;
                                }
                            });
                        });
                    });

                    registrationFormComplete = (hasEmail && hasFirstName) || hasSFSearch;

                    if (!hasEmail) {
                        designWarnings.push("The form must include an Email field");
                    }
                    if (!hasFirstName) {
                        designWarnings.push("The form must include a First Name field");
                    }
                } else {
                    const hasPages = baseRegistrationFlowConfiguration.form.pages.length > 0;
                    const hasSections = hasPages &&
                        baseRegistrationFlowConfiguration.form.pages[0].sections.length > 0;
                    const hasFields = hasSections &&
                        baseRegistrationFlowConfiguration.form.pages[0].sections[0].fields.length > 0;

                    registrationFormComplete = hasPages && hasSections && hasFields;

                    if (!hasPages) {
                        designWarnings.push("The form must have at least one page");
                    } else if (!hasSections) {
                        designWarnings.push("The form must have at least one section");
                    } else if (!hasFields) {
                        designWarnings.push("The form must have at least one field");
                    }
                }

                // Check confirmation section requirements
                if (baseRegistrationFlowConfiguration.form.enableSubmissionReview) {
                    if (!baseRegistrationFlowConfiguration.form.submissionReviewTitle ||
                        baseRegistrationFlowConfiguration.form.submissionReviewTitle.trim() === '') {
                        confirmationWarnings.push("Review Page Title is missing");
                    }
                    if (!baseRegistrationFlowConfiguration.form.submissionReviewSubtitle) {
                        confirmationWarnings.push("Review Page Description is missing");
                    }
                }

                if (!baseRegistrationFlowConfiguration.form.successTitle ||
                    baseRegistrationFlowConfiguration.form.successTitle.trim() === '') {
                    confirmationWarnings.push("Submission Success Title is missing");
                }
                if (!baseRegistrationFlowConfiguration.form.successSubtitle) {
                    confirmationWarnings.push("Submission Success Description is missing");
                }

                // Check confirmation email if enabled
                let confirmationEmailComplete = !baseRegistrationFlowConfiguration.form.confirmationEmailEnabled;
                if (baseRegistrationFlowConfiguration.form.confirmationEmailEnabled) {
                    if (!baseRegistrationFlowConfiguration.form.confirmationEmail) {
                        confirmationEmailWarnings.push("Confirmation Email template needs to be selected");
                        confirmationEmailComplete = false;
                    } else {
                        const senderNameMissing = !(baseRegistrationFlowConfiguration.form.confirmationEmail.senderName || '').trim();
                        const senderEmailMissing = !(baseRegistrationFlowConfiguration.form.confirmationEmail.senderEmail || '').trim();
                        const subjectMissing = !(baseRegistrationFlowConfiguration.form.confirmationEmail.subject || '').trim();

                        if (senderNameMissing) {
                            confirmationEmailWarnings.push("Confirmation Email From Name is missing");
                        }
                        if (senderEmailMissing) {
                            confirmationEmailWarnings.push("Confirmation Email From Email is missing");
                        }
                        if (subjectMissing) {
                            confirmationEmailWarnings.push("Confirmation Email Subject is missing");
                        }

                        confirmationEmailComplete = !senderNameMissing && !senderEmailMissing && !subjectMissing;
                    }
                }

                if (baseRegistrationFlowConfiguration.page.openToPublic && !event.allowPublicRegistrations) {
                    setupWarnings.push("Public registration is disabled for this event. Please enable it to allow public access to the registration page.");
                }

                // Determine overall completeness
                let configurationComplete = setupWarnings.length === 0 &&
                    designWarnings.length === 0 &&
                    confirmationWarnings.length === 0 &&
                    pageDesignComplete &&
                    registrationFormComplete &&
                    (baseRegistrationFlowConfiguration.ticketingEnabled ? ticketingComplete : true) &&
                    (baseRegistrationFlowConfiguration.form.confirmationEmailEnabled ? confirmationEmailComplete : true);


                return (
                    <div className="blocksContainer">
                        <div className="flex w-100">
                            <div className="sectionBlock mr-25 contained-h">
                                <div className="outlineCard">
                                    <p className="mb-20">
                                        Ready to launch this registration flow?<br />
                                        Just toggle the switch below to publish and then share with your attendees.
                                    </p>
                                    <ToggleField
                                        label={<strong>Get started by publishing the page</strong>}
                                        icons={false}
                                        checked={registrationFlowConfiguration.page.published}
                                        disabled={!configurationComplete}
                                        onChange={(val) => {
                                            this.setState({
                                                registrationFlowConfiguration: {
                                                    ...registrationFlowConfiguration,
                                                    page: {
                                                        ...registrationFlowConfiguration.page,
                                                        published: val.target.checked,
                                                    },
                                                },
                                                editing: true,
                                            });
                                        }}
                                    />
                                    {!configurationComplete && (
                                        <div>
                                            <p className="mt-20 mb-20 modalErrorMessage small">
                                                It appears that the registration flow is incomplete.<br />
                                                Please finish setting up the unchecked items to publish the registration page:
                                            </p>
                                        </div>
                                    )}

                                    <div className={`mt-10 flex aic gap5 ${setupWarnings.length === 0 ? "blue" : "neu"}`}>
                                        {setupWarnings.length === 0 ?
                                            <i className="las la-check-circle"></i> :
                                            <i className="las la-times-circle"></i>}
                                        <p className={`small`}>General setup details</p>
                                    </div>
                                    {setupWarnings.length > 0 && (
                                        <div className="mt-5 ml-20">
                                            {setupWarnings.map((warning, index) => (
                                                <p key={index} className="small red mb-5">{warning}</p>
                                            ))}
                                        </div>
                                    )}

                                    {baseRegistrationFlowConfiguration.ticketingEnabled && (
                                        <>
                                            <div className={`mt-10 flex aic gap5 ${ticketingComplete ? "blue" : "neu"}`}>
                                                {ticketingComplete ?
                                                    <i className="las la-check-circle"></i> :
                                                    <i className="las la-times-circle"></i>}
                                                <p className={`small`}>Registration tickets</p>
                                            </div>
                                            {ticketWarnings.length > 0 && (
                                                <div className="mt-5 ml-20">
                                                    {ticketWarnings.map((warning, index) => (
                                                        <p key={index} className="small red mb-5">{warning}</p>
                                                    ))}
                                                </div>
                                            )}
                                        </>
                                    )}

                                    <div className={`mt-10 flex aic gap5 ${registrationFormComplete ? "blue" : "neu"}`}>
                                        {registrationFormComplete ?
                                            <i className="las la-check-circle"></i> :
                                            <i className="las la-times-circle"></i>}
                                        <p className={`small`}>Registration form</p>
                                    </div>

                                    <div className={`mt-10 flex aic gap5 ${pageDesignComplete ? "blue" : "neu"}`}>
                                        {pageDesignComplete ?
                                            <i className="las la-check-circle"></i> :
                                            <i className="las la-times-circle"></i>}
                                        <p className={`small`}>Registration page design</p>
                                    </div>

                                    <div className={`mt-10 flex aic gap5 ${designWarnings.length === 0 ? "blue" : "neu"}`}>
                                        {designWarnings.length === 0 ?
                                            <i className="las la-check-circle"></i> :
                                            <i className="las la-times-circle"></i>}
                                        <p className={`small`}>Form configuration</p>
                                    </div>
                                    {designWarnings.length > 0 && (
                                        <div className="mt-5 ml-20">
                                            {designWarnings.map((warning, index) => (
                                                <p key={index} className="small red mb-5">{warning}</p>
                                            ))}
                                        </div>
                                    )}

                                    <div className={`mt-10 flex aic gap5 ${confirmationWarnings.length === 0 ? "blue" : "neu"}`}>
                                        {confirmationWarnings.length === 0 ?
                                            <i className="las la-check-circle"></i> :
                                            <i className="las la-times-circle"></i>}
                                        <p className={`small`}>Confirmation details</p>
                                    </div>
                                    {confirmationWarnings.length > 0 && (
                                        <div className="mt-5 ml-20">
                                            {confirmationWarnings.map((warning, index) => (
                                                <p key={index} className="small red mb-5">{warning}</p>
                                            ))}
                                        </div>
                                    )}

                                    {baseRegistrationFlowConfiguration.form.confirmationEmailEnabled && (
                                        <div className={`mt-10 flex aic gap5 ${confirmationEmailComplete ? "blue" : "neu"}`}>
                                            {confirmationEmailComplete ?
                                                <i className="las la-check-circle"></i> :
                                                <i className="las la-times-circle"></i>}
                                            <p className={`small`}>Confirmation email</p>
                                        </div>
                                    )}
                                    {baseRegistrationFlowConfiguration.form.confirmationEmailEnabled && !confirmationEmailComplete && (
                                        <div className="mt-5 ml-20">
                                            {confirmationEmailWarnings.map((warning, index) => (
                                                    <p key={index} className="small red mb-5">{warning}</p>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                {baseRegistrationFlowConfiguration.page.published && (
                                    <>
                                        <div>
                                            <h2 className="blockHeader">
                                                Include this link in an invitation email or share it directly with your attendees
                                            </h2>
                                            <div className={`flex aic gap10`}>
                                                <InputField
                                                    label="Registration page link"
                                                    required={false}
                                                    disabled={true}
                                                    value={this.props.organization.hostname ?
                                                        `https://${this.props.organization.hostname}/${this.props.event.nameSlug}/${registrationFlowConfiguration.page.pathSlug}` :
                                                        `https://${this.props.organization.identifier}.simple.events/${this.props.event.nameSlug}/${registrationFlowConfiguration.page.pathSlug}`
                                                    }
                                                    readOnly
                                                />
                                                <button
                                                    className={`neu ${this.state.linkCopied ? 'disabled' : ''}`}
                                                    onClick={this.handleCopyRegLink}
                                                >
                                                    {this.state.linkCopied ? 'Link Copied' : `Copy link`}
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                );
            case "payments":
                return (
                    <Payments
                        payments={baseRegistrationFlowConfiguration.payments || []}
                        name={baseRegistrationFlowConfiguration.name}
                    />
                );
            case "integrations":
                const formFields = {};
                baseRegistrationFlowConfiguration.form.pages.forEach(page => {
                    page.sections.forEach(section => {
                        section.fields.forEach(field => {
                            if (field?.nestedSections?.length > 0) {
                                field.nestedSections.forEach(nestedSection => {
                                    nestedSection.questions.forEach(nestedField => {
                                        const nestedId = nestedField.id
                                        formFields[nestedId] = nestedField;
                                    });
                                });
                            }
                            formFields[field.id] = field;
                        });
                    });
                });
                const formFieldOptions = Object.keys(formFields).map(key => ({
                    label: formFields[key].label,
                    value: formFields[key].id,
                }));
                return (
                    <div className="blocksContainer">
                        <div className="flex w-100 gap20">
                            <div className="sectionBlock contained-h">
                                <h2 className="blockHeader">Salesforce Options</h2>
                                <ToggleField
                                    label="Submit registrant as lead in campaign"
                                    checked={registrationFlowConfiguration.salesforceLeadEnabled}
                                    icons={false}
                                    disabled={!event.integrations?.salesforce?.campaignName}
                                    information={!event.integrations?.salesforce?.campaignName ? "Please set up a Salesforce Campaign to enable this option." : false}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                salesforceLeadEnabled: e.target.checked,
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                                {registrationFlowConfiguration.salesforceLeadEnabled && (<div className="flex gap10">
                                    <InputField
                                        label="Custom Lookup Field"
                                        classes={"w-100"}
                                        type="text"
                                        name="customLookupField"
                                        information="Custom Field ID from Salesforce to use in query for existing lead or contact if email is not found."
                                        placeholder="Custom_Field__c"
                                        value={registrationFlowConfiguration.salesforceCustomLeadQuery?.fieldName || ''}
                                        onChange={(e) => {
                                            this.setState({
                                                registrationFlowConfiguration: {
                                                    ...registrationFlowConfiguration,
                                                    salesforceCustomLeadQuery: {
                                                        ...registrationFlowConfiguration.salesforceCustomLeadQuery,
                                                        fieldName: e.target.value,
                                                    },
                                                },
                                                editing: true,
                                            });
                                        }}
                                        min={registrationFlowConfiguration.startDate}
                                    />
                                    <SelectField
                                        label="Lookup Form Field"
                                        classes="w-100"
                                        information="Choose the field to pull the data from in form"
                                        placeholder="Form field"
                                        value={
                                            formFieldOptions.find(option => option.value === registrationFlowConfiguration.salesforceCustomLeadQuery?.fieldId)
                                        }
                                        onChange={(e) => {
                                            this.setState({
                                                registrationFlowConfiguration: {
                                                    ...registrationFlowConfiguration,
                                                    salesforceCustomLeadQuery: {
                                                        ...registrationFlowConfiguration.salesforceCustomLeadQuery,
                                                        fieldId: e.value,
                                                    },
                                                },
                                                editing: true,
                                            });
                                        }}
                                        options={formFieldOptions}
                                    />

                                </div>)}
                                {registrationFlowConfiguration.salesforceLeadEnabled && (
                                    <div className="mt-20">
                                        <h2 className="blockHeader">New Lead Details</h2>
                                        <p className="small mb-10">Fields to populate on new Salesforce leads created from this registration.</p>
                                        {(registrationFlowConfiguration.newLeadCustomFields || []).map((field, index) => (
                                            <div key={index} className="flex gap10 mb-10 flex-ac">
                                                <InputField
                                                    label="Custom Field Name"
                                                    classes={"w-100"}
                                                    type="text"
                                                    information="Custom Field ID from Salesforce to populate on new leads."
                                                    placeholder="Custom_Field__c"
                                                    value={field.fieldName || ''}
                                                    onChange={(e) => {
                                                        const updatedFields = [...(registrationFlowConfiguration.newLeadCustomFields || [])];
                                                        updatedFields[index] = { ...updatedFields[index], fieldName: e.target.value };
                                                        this.setState({
                                                            registrationFlowConfiguration: {
                                                                ...registrationFlowConfiguration,
                                                                newLeadCustomFields: updatedFields,
                                                            },
                                                            editing: true,
                                                        });
                                                    }}
                                                />
                                                <SelectField
                                                    label="Form Field"
                                                    classes="w-100"
                                                    information="Choose the field to pull the data from in form"
                                                    placeholder="Form field"
                                                    value={formFieldOptions.find(option => option.value === field.fieldId)}
                                                    onChange={(e) => {
                                                        const updatedFields = [...(registrationFlowConfiguration.newLeadCustomFields || [])];
                                                        updatedFields[index] = { ...updatedFields[index], fieldId: e.value };
                                                        this.setState({
                                                            registrationFlowConfiguration: {
                                                                ...registrationFlowConfiguration,
                                                                newLeadCustomFields: updatedFields,
                                                            },
                                                            editing: true,
                                                        });
                                                    }}
                                                    options={formFieldOptions}
                                                />
                                                <i
                                                    className="las la-times c-pointer mt-20"
                                                    style={{ fontSize: 20 }}
                                                    onClick={() => {
                                                        const updatedFields = (registrationFlowConfiguration.newLeadCustomFields || []).filter((_, i) => i !== index);
                                                        this.setState({
                                                            registrationFlowConfiguration: {
                                                                ...registrationFlowConfiguration,
                                                                newLeadCustomFields: updatedFields,
                                                            },
                                                            editing: true,
                                                        });
                                                    }}
                                                />
                                            </div>
                                        ))}
                                        {(() => {
                                            const fields = registrationFlowConfiguration.newLeadCustomFields || [];
                                            const canAdd = fields.length === 0 || (fields[fields.length - 1].fieldName && fields[fields.length - 1].fieldId);
                                            return (
                                                <div
                                                    className={`flex jcc mt-10 ${canAdd ? 'c-pointer' : 'disabled'}`}
                                                    style={{ opacity: canAdd ? 1 : 0.4, cursor: canAdd ? 'pointer' : 'not-allowed' }}
                                                    onClick={() => {
                                                        if (!canAdd) return;
                                                        const updatedFields = [...fields, { fieldName: '', fieldId: '' }];
                                                        this.setState({
                                                            registrationFlowConfiguration: {
                                                                ...registrationFlowConfiguration,
                                                                newLeadCustomFields: updatedFields,
                                                            },
                                                            editing: true,
                                                        });
                                                    }}
                                                >
                                                    + Add Field
                                                </div>
                                            );
                                        })()}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>);
            default:
                return null;
        }
    };

    updateCustomFields = (customFieldData) => {
        const updatedCustomFields = [...this.state.customBaseFields];

        // Find if category already exists
        const existingCategoryIndex = updatedCustomFields.findIndex(
            category => category.title === customFieldData.title
        );

        if (existingCategoryIndex > -1) {
            // Add new field to existing category
            const newField = {
                _id: customFieldData.fields[customFieldData.fields.length - 1]._id,
                fieldName: customFieldData.fields[customFieldData.fields.length - 1].fieldName,
                fieldType: customFieldData.fields[customFieldData.fields.length - 1].fieldType,
                required: false,
                disabled: false,
                propertyType: 'attendee'
            };
            updatedCustomFields[existingCategoryIndex].fields.push(newField);
        } else {
            const newCategory = {
                _id: 'custom',
                title: customFieldData.title,
                fields: customFieldData.fields.map((field) => ({
                    _id: field._id,
                    fieldName: field.fieldName,
                    fieldType: field.fieldType,
                    required: false,
                    disabled: false,
                    propertyType: 'attendee'
                }))
            };
            updatedCustomFields.push(newCategory);
        }

        this.setState({ customBaseFields: updatedCustomFields });
    };

    updateSelected = (_selectedIndex, selectedId) => {
        this.setState({ selectedSection: selectedId });
    };

    render() {
        const {
            baseRegistrationFlowConfiguration,
            loading,
            selectedSection,
            editing,
            tabs,
            addTicketModalOpen,
            registrationFlowConfiguration,
            editingRegistrationForm,
            formBuilderModalOpen,
            pageBuilderModalOpen,
            emailBuilderModalOpen,
            emailTemplateModalOpen,
            additionalAttendeeEmailBuilderModalOpen,
            additionalAttendeeEmailTemplateModalOpen,
            keyedMetadata,
            keyedData,
            deleteFlowModalOpen,
        } = this.state;

        const { event, orgId, eventId } = this.props;

        const hasSalesforceIntegration = event.integrations && event.integrations.salesforce ? true : false;
        const salesforceLeadEnabled = baseRegistrationFlowConfiguration ? baseRegistrationFlowConfiguration.salesforceLeadEnabled : false;
        const hasSalesforceFields = baseRegistrationFlowConfiguration && baseRegistrationFlowConfiguration.form && baseRegistrationFlowConfiguration.form.pages ? baseRegistrationFlowConfiguration.form.pages.some(page =>
            page.sections.some(section =>
                section.fields.some(field =>
                    field.type === 'salesForceSearchContact' || field.type === 'salesForceSearchAccount'
                )
            )
        ) : false;
        const showAlertBar = hasSalesforceIntegration && (!salesforceLeadEnabled && !hasSalesforceFields);

        return (
            <div className="sectionContainer">
                {!loading && showAlertBar && <AlertBar style={{ background: '#b90000' }} message={"This form is not connected to Salesforce and is not sending attendee data."} type="error" />}

                <SectionHeader
                    style={!loading && showAlertBar ? { marginTop: 20 } : {}}
                    title={baseRegistrationFlowConfiguration.name}
                    breadcrumbs={[
                        {
                            name: event.name,
                        },
                        {
                            name: "Registration Flows",
                        },
                    ]}
                    directLink={`/${orgId}/events/${event._id}/registrationFlows`}
                    subActions={[
                        {
                            label: "Delete",
                            iconClass: "las la-trash red",
                            onClick: () => {
                                this.setState({ deleteFlowModalOpen: true });
                            },
                        },
                    ]}
                >
                    <TabsContainer
                        tabs={tabs}
                        updateSelected={this.updateSelected}
                        selectedIndex={tabs.findIndex((tab) => tab.id === selectedSection)}
                    />
                </SectionHeader>
                <div className="sectionBody">
                    {!loading && this.renderSection()}
                    {loading && (
                        <LoadingWizard text="Loading Registration Flow" loading={true} />
                    )}
                </div>
                {selectedSection !== 'submissions' ?
                    <SectionFooter
                        updatedAt={baseRegistrationFlowConfiguration.updatedAt}
                        saveEdit={this.saveRegistrationFlowConfiguration}
                        cancelEdit={this.cancelEdit}
                        editing={editing}
                        lastEditedBy={""}
                    /> :
                    <ActionButtonContainer
                        batchActions={[{
                            type: 'button',
                            label: 'Delete Submission',
                            iconClass: 'las la-trash-alt',
                            class: 'danger',
                            onClick: this.toggleDeleteSubmission
                        }]}
                        checkedEntryCount={Object.keys(this.state.checkedSubmission).length}
                        entriesLength={baseRegistrationFlowConfiguration.form.submissions ? baseRegistrationFlowConfiguration.form.submissions.length : 0}
                        uncheckEntries={this.cancelSubmissionEdit}
                    />}

                {addTicketModalOpen && (
                    <CreateRegistrationFlowTicketModal
                        isOpen={addTicketModalOpen}
                        toggle={() => {
                            this.setState({ addTicketModalOpen: false });
                        }}
                        flowId={this.props.match.params.flowId}
                        orgId={this.props.orgId}
                        eventId={this.props.eventId}
                        updateFlow={(ticket) => {
                            this.setState(
                                (prevState) => ({
                                    registrationFlowConfiguration: {
                                        ...prevState.registrationFlowConfiguration,
                                        tickets: [
                                            ...prevState.registrationFlowConfiguration.tickets,
                                            ticket,
                                        ],
                                    },
                                    baseRegistrationFlowConfiguration: {
                                        ...prevState.baseRegistrationFlowConfiguration,
                                        tickets: [
                                            ...prevState.baseRegistrationFlowConfiguration.tickets,
                                            ticket,
                                        ],
                                    },
                                    addTicketModalOpen: false,
                                }),
                                this.updateFlowTickets
                            );
                        }}
                    />
                )}

                {formBuilderModalOpen && (
                    <FormBuilderModal
                        isOpen={formBuilderModalOpen}
                        editing={editingRegistrationForm}
                        toggle={() => {
                            this.setState({ formBuilderModalOpen: false });
                        }}
                        form={registrationFlowConfiguration.form}
                        editedForm={registrationFlowConfiguration.form}
                        fields={this.props.fields}
                        baseFieldList={[...baseFieldList]}
                        links={{ get: `` }}
                        updateForm={(form) => {
                            this.setState({
                                registrationFlowConfiguration: {
                                    ...registrationFlowConfiguration,
                                    form: {
                                        ...registrationFlowConfiguration.form,
                                        ...form,
                                    },
                                },
                                editingRegistrationForm: true,
                            });
                        }}
                        cancelEdit={() => {
                            this.setState({
                                registrationFlowConfiguration: {
                                    ...registrationFlowConfiguration,
                                    form: JSON.parse(
                                        JSON.stringify(baseRegistrationFlowConfiguration.form)
                                    ),
                                },
                                editingRegistrationForm: false,
                            });
                        }}
                        emails={this.state.availableEmails}
                        orgId={orgId}
                        eventId={eventId}
                        addNewField={this.props.addNewField}
                        saveForm={this.saveRegistrationForm}
                        customFields={this.state.metadataOptions}
                        customFieldList={[...this.state.customBaseFields]}
                        groups={event.groups}
                        inventory={this.props.inventory}
                        updateCustomFields={this.updateCustomFields}
                    />
                )}

                {pageBuilderModalOpen && (
                    <PageEditor
                        scope="event"
                        isOpen={pageBuilderModalOpen}
                        toggle={() =>
                            this.setState({ pageBuilderModalOpen: !pageBuilderModalOpen })
                        }
                        lockForm={true}
                        page={baseRegistrationFlowConfiguration.page}
                        editedPage={registrationFlowConfiguration.page}
                        updatePage={this.updatePage}
                        cancelEdit={() => {
                            this.setState({
                                registrationFlowConfiguration: {
                                    ...registrationFlowConfiguration,
                                    page: baseRegistrationFlowConfiguration.page,
                                },
                                editing: false,
                            });
                        }}
                        event={this.props.event}
                        orgId={orgId}
                        eventId={eventId}
                        pageId={registrationFlowConfiguration.page._id}
                    />
                )}

                {emailBuilderModalOpen && (
                    <EmailEditor
                        isOpen={emailBuilderModalOpen}
                        emailTemplate={registrationFlowConfiguration.form.confirmationEmail}
                        orgId={orgId}
                        eventId={eventId}
                        keyedMetadata={keyedMetadata}
                        keyedData={keyedData}
                        event={event}
                        branding={event.branding}
                        url={`${ENV}Organizations/${orgId}/emailrenderer`}
                        method={"post"}
                        postData={registrationFlowConfiguration.form.confirmationEmail}
                        toggle={() => {
                            this.setState({ emailBuilderModalOpen: false });
                        }}
                        update={this.updateTemplateHtml}
                        cancelEdit={this.cancelEdit}
                        links={{
                            getAssets: `Organizations/${orgId}/events/${eventId}/assets`,
                            addAssets: `Organizations/${orgId}/events/${eventId}/assets`,
                        }}
                        isEmailTemplate={true}
                    />
                )}

                {emailTemplateModalOpen && (
                    <TemplateCenterModal
                        isOpen={emailTemplateModalOpen}
                        orgId={orgId}
                        templates={this.state.templates}
                        platformTemplates={this.state.platformTemplates}
                        eventId={eventId}
                        event={this.props.event}
                        keyedMetadata={keyedMetadata}
                        toggle={() => {
                            const hasTemplate = registrationFlowConfiguration.form.confirmationEmail != null;
                            this.setState({ emailTemplateModalOpen: false, editing: hasTemplate});
                        }}
                        addCampaign={(template) => {
                            const enrichedTemplate = {
                                ...template,
                                senderEmail: template.senderEmail || this.state.defaultSenderEmail || '',
                                senderName: template.senderName || this.state.defaultSenderName || '',
                            };
                            this.setState(
                                {
                                    registrationFlowConfiguration: {
                                        ...registrationFlowConfiguration,
                                        form: {
                                            ...registrationFlowConfiguration.form,
                                            confirmationEmail: enrichedTemplate,
                                        },
                                    },
                                    emailTemplateModalOpen: false,
                                    editing: true,
                                },
                                () => {
                                    this.updateConfirmationEmailDomainState(enrichedTemplate);
                                    this.saveRegistrationForm();
                                }
                            );
                        }}
                        defaultSenderEmail={this.state.defaultSenderEmail}
                        defaultSenderName={this.state.defaultSenderName}
                        isTemplate={true}
                    />
                )}

                {additionalAttendeeEmailBuilderModalOpen && (
                    <EmailEditor
                        isOpen={additionalAttendeeEmailBuilderModalOpen}
                        emailTemplate={registrationFlowConfiguration.form.additionalAttendeeConfirmationEmail}
                        orgId={orgId}
                        eventId={eventId}
                        keyedMetadata={keyedMetadata}
                        keyedData={keyedData}
                        event={event}
                        branding={event.branding}
                        url={`${ENV}Organizations/${orgId}/emailrenderer`}
                        method={"post"}
                        postData={registrationFlowConfiguration.form.additionalAttendeeConfirmationEmail}
                        toggle={() => {
                            this.setState({ additionalAttendeeEmailBuilderModalOpen: false });
                        }}
                        update={this.updateAdditionalAttendeeTemplateHtml}
                        cancelEdit={this.cancelEdit}
                        links={{
                            getAssets: `Organizations/${orgId}/events/${eventId}/assets`,
                            addAssets: `Organizations/${orgId}/events/${eventId}/assets`,
                        }}
                        isEmailTemplate={true}
                    />
                )}

                {additionalAttendeeEmailTemplateModalOpen && (
                    <TemplateCenterModal
                        isOpen={additionalAttendeeEmailTemplateModalOpen}
                        orgId={orgId}
                        templates={this.state.templates}
                        platformTemplates={this.state.platformTemplates}
                        eventId={eventId}
                        event={this.props.event}
                        keyedMetadata={keyedMetadata}
                        toggle={() => {
                            this.setState({ additionalAttendeeEmailTemplateModalOpen: false });
                        }}
                        addCampaign={(template) => {
                            this.setState(
                                {
                                    registrationFlowConfiguration: {
                                        ...registrationFlowConfiguration,
                                        form: {
                                            ...registrationFlowConfiguration.form,
                                            additionalAttendeeConfirmationEmail: template,
                                        },
                                    },
                                    additionalAttendeeEmailTemplateModalOpen: false,
                                },
                                this.saveRegistrationForm
                            );
                        }}
                        defaultSenderEmail={this.state.defaultSenderEmail}
                        defaultSenderName={this.state.defaultSenderName}
                        isTemplate={true}
                    />
                )}

                {this.state.editTicketModalOpen && (
                    <EditTicketModal
                        isOpen={this.state.editTicketModalOpen}
                        toggle={() => {
                            this.setState({ editTicketModalOpen: false });
                        }}
                        ticket={this.state.editingTicket}
                        flowId={this.props.match.params.flowId}
                        orgId={this.props.orgId}
                        eventId={this.props.eventId}
                        updateTicket={(updatedTicket) => {
                            const updatedTickets =
                                this.state.registrationFlowConfiguration.tickets.map((ticket) =>
                                    ticket._id === updatedTicket._id ? updatedTicket : ticket
                                );

                            this.setState(
                                {
                                    registrationFlowConfiguration: {
                                        ...this.state.registrationFlowConfiguration,
                                        tickets: updatedTickets,
                                    },
                                    baseRegistrationFlowConfiguration: {
                                        ...this.state.baseRegistrationFlowConfiguration,
                                        tickets: updatedTickets,
                                    },
                                    editTicketModalOpen: false,
                                },
                                this.updateFlowTickets
                            );
                        }}
                    />
                )}

                {this.state.deleteTicketModalOpen && (
                    <DeleteTicketModal
                        isOpen={this.state.deleteTicketModalOpen}
                        toggle={() => {
                            this.setState({ deleteTicketModalOpen: false });
                        }}
                        ticket={this.state.deletingTicket}
                        flowId={this.props.match.params.flowId}
                        orgId={this.props.orgId}
                        eventId={this.props.eventId}
                        onDelete={(ticketId) => {
                            const updatedTickets =
                                this.state.registrationFlowConfiguration.tickets.filter(
                                    (ticket) => ticket._id !== ticketId
                                );

                            this.setState(
                                {
                                    registrationFlowConfiguration: {
                                        ...this.state.registrationFlowConfiguration,
                                        tickets: updatedTickets,
                                    },
                                    baseRegistrationFlowConfiguration: {
                                        ...this.state.baseRegistrationFlowConfiguration,
                                        tickets: updatedTickets,
                                    },
                                    deleteTicketModalOpen: false,
                                },
                                this.updateFlowTickets
                            );
                        }}
                    />
                )}

                {this.state.duplicateTicketModalOpen && (
                    <DuplicateTicketModal
                        isOpen={this.state.duplicateTicketModalOpen}
                        toggle={() => {
                            this.setState({ duplicateTicketModalOpen: false });
                        }}
                        ticket={this.state.duplicatingTicket}
                        flowId={this.props.match.params.flowId}
                        orgId={this.props.orgId}
                        eventId={this.props.eventId}
                        onDuplicate={(newTicket) => {
                            this.setState(
                                {
                                    registrationFlowConfiguration: {
                                        ...this.state.registrationFlowConfiguration,
                                        tickets: [
                                            ...this.state.registrationFlowConfiguration.tickets,
                                            newTicket,
                                        ],
                                    },
                                    baseRegistrationFlowConfiguration: {
                                        ...this.state.baseRegistrationFlowConfiguration,
                                        tickets: [
                                            ...this.state.baseRegistrationFlowConfiguration.tickets,
                                            newTicket,
                                        ],
                                    },
                                    duplicateTicketModalOpen: false,
                                },
                                this.updateFlowTickets
                            );
                        }}
                    />
                )}

                {deleteFlowModalOpen && (
                    <DeleteFlowModal
                        flow={baseRegistrationFlowConfiguration}
                        isOpen={deleteFlowModalOpen}
                        toggle={() => {
                            this.setState({ deleteFlowModalOpen: false });
                        }}
                        orgId={orgId}
                        eventId={eventId}
                        onDelete={(flowId) => {
                            this.props.removeFlow(flowId);
                            this.props.history.push(
                                `/${orgId}/events/${eventId}/registrationFlows`
                            );
                        }}
                    />
                )}

                {this.state.toggleDeleteSubmission && (
                    <DeleteSubmissionModal
                        toggle={this.toggleDeleteSubmission}
                        isOpen={this.state.toggleDeleteSubmission}
                        deleteSubmission={this.deleteFormSubmission}
                        selectedSubmissionCount={Object.keys(this.state.checkedSubmission).length}
                    />
                )}

                {this.state.toggleSendTestEmail && (
                    <SendTestTemplateModal
                        isOpen={this.state.toggleSendTestEmail}
                        template={registrationFlowConfiguration.form.confirmationEmail}
                        orgId={orgId}
                        eventId={eventId}
                        event={event}
                        toggle={this.toggleSendTestEmailModal}
                    />
                )}
            </div>
        );
    }
}

export default withRouter(RegistrationFlowSetup);
